// import React, { useState, useEffect, useRef } from 'react';
// import axios from 'axios';
// // import { Button, Modal, Form, Offcanvas, Card, Row, Col, Badge, Table } from 'react-bootstrap';
// import ReactPaginate from 'react-paginate';
// import withPermission from '../../../utils/withPermission';
// import Swal from 'sweetalert2';
// import CreatableSelect from 'react-select/creatable';
// // import { FaPlus, FaSearch, FaFilter, FaEdit, FaTrash, FaEye, FaDownload, FaCog, FaTimes, FaSave, FaTrashAlt } from 'react-icons/fa';
// import { FaPlus, FaTimes, FaEdit, FaCheck, FaFileExport, FaEye } from 'react-icons/fa';
// import { Modal, Button, Form, Row, Col, Card, Badge, Table } from 'react-bootstrap';
// const backendUrl = process.env.REACT_APP_BACKEND_URL;

// const API_URL = `${backendUrl}/api/payroll-cycles`;
// const CATEGORY_API_URL = `${backendUrl}/api/categories?type=expense`;
// const webzashUrl = process.env.REACT_APP_WEBZASH_URL || 'http://localhost/webzash-integration';
// const months = [
//     { value: 1, label: "January" },
//     { value: 2, label: "February" },
//     { value: 3, label: "March" },
//     { value: 4, label: "April" },
//     { value: 5, label: "May" },
//     { value: 6, label: "June" },
//     { value: 7, label: "July" },
//     { value: 8, label: "August" },
//     { value: 9, label: "September" },
//     { value: 10, label: "October" },
//     { value: 11, label: "November" },
//     { value: 12, label: "December" },
// ];
// const years = Array.from({ length: 20 }, (_, i) => new Date().getFullYear() - 5 + i);

// // const PayrollCycleList = () => {
// //     const [allowances, setAllowances] = useState([]);
// //     const [showModal, setShowModal] = useState(false);
// //     const [formData, setFormData] = useState({ name: "", description: "" });
// //     const [isEdit, setIsEdit] = useState(false);
// //     const [selectedAllowance, setSelectedAllowance] = useState(null);
// //     const [currentPage, setCurrentPage] = useState(1);
// //     const [pageCount, setPageCount] = useState(1);
// //     const [errors, setErrors] = useState({});
// //     const [searchQuery, setSearchQuery] = useState("");
// //     const debounceTimeoutRef = useRef(null);
// //     const [month, setMonth] = useState(new Date().getMonth() + 1);
// //     const [year, setYear] = useState(new Date().getFullYear());
// //     const [cycle, setCycle] = useState(null);
// //     const [payslips, setPayslips] = useState([]);
// //     const [loading, setLoading] = useState(false);
// //     const [showFilters, setShowFilters] = useState(false);
// //     const [showEmployeeModal, setShowEmployeeModal] = useState(false);
// //     const [selectedEmployee, setSelectedEmployee] = useState(null);
// //     const [employeeDetails, setEmployeeDetails] = useState(null);
// //     const [loadingEmployee, setLoadingEmployee] = useState(false);

// //     const WithEditPermission = withPermission(({ children }) => children, ["allowance-edit"]);
// //     const WithDeletePermission = withPermission(({ children }) => children, ["allowance-delete"]);
// //     const WithCreatePermission = withPermission(({ children }) => children, ["allowance-create"]);

// //     const months = [
// //         { value: 1, label: "January" },
// //         { value: 2, label: "February" },
// //         { value: 3, label: "March" },
// //         { value: 4, label: "April" },
// //         { value: 5, label: "May" },
// //         { value: 6, label: "June" },
// //         { value: 7, label: "July" },
// //         { value: 8, label: "August" },
// //         { value: 9, label: "September" },
// //         { value: 10, label: "October" },
// //         { value: 11, label: "November" },
// //         { value: 12, label: "December" }
// //     ];

// //     const years = Array.from({ length: 10 }, (_, i) => new Date().getFullYear() - 5 + i);



// //     const handlePageChange = ({ selected }) => {
// //         const newPage = selected + 1;
// //         setCurrentPage(newPage);
// //     };

// //     const token = JSON.parse(localStorage.getItem("user-info"))?.token;
// //     const origin = localStorage.getItem("user-origin");

// //     useEffect(() => {
// //         fetchCycle();
// //     }, [month, year]);

// //     const fetchCycle = async () => {
// //         try {
// //             const res = await axios.get(
// //                 `${process.env.REACT_APP_BACKEND_URL}/api/payroll-cycles`,
// //                 {
// //                     headers: { Authorization: `Bearer ${token}`, "Tenant-Origin": origin },
// //                     params: { month, year },
// //                 }
// //             );

// //             // Find the cycle for selected month & year
// //             const currentCycle = res.data.find(
// //                 (c) => parseInt(c.month) === parseInt(month) && parseInt(c.year) === parseInt(year)
// //             );


// //             if (currentCycle) {
// //                 setCycle(currentCycle);
// //                 // You can fetch payslips for this cycle if needed
// //                 const payslipsRes = await axios.get(
// //                     `${process.env.REACT_APP_BACKEND_URL}/api/payroll/cycle/${currentCycle.id}/payslips`,
// //                     { headers: { Authorization: `Bearer ${token}`, "Tenant-Origin": origin } }
// //                 );
// //                 setPayslips(payslipsRes.data || []);
// //             } else {
// //                 setCycle(null);
// //                 setPayslips([]);
// //             }
// //         } catch (err) {
// //             console.error(err);
// //             setCycle(null);
// //             setPayslips([]);
// //         }
// //     };

// //     const handleCreateCycle = async () => {
// //         try {
// //             const res = await axios.post(
// //                 `${process.env.REACT_APP_BACKEND_URL}/api/payroll-cycles`,
// //                 { month, year },
// //                 { headers: { Authorization: `Bearer ${token}`, "Tenant-Origin": origin } }
// //             );
// //             setCycle(res.data.cycle);
// //             setPayslips([]);
// //             fetchCycle();

// //             Swal.fire("Success!", "Payroll cycle created successfully.", "success");
// //         } catch (err) {
// //             Swal.fire("Error!", err.response?.data?.message || "Error creating cycle", "error");
// //         }
// //     };

// //     const handleProcessCycle = async () => {
// //         if (!cycle) return;
// //         try {
// //             await axios.post(
// //                 `${process.env.REACT_APP_BACKEND_URL}/api/payroll/cycle/${cycle.id}/process`,
// //                 {},
// //                 { headers: { Authorization: `Bearer ${token}`, "Tenant-Origin": origin } }
// //             );
// //             Swal.fire("Success!", "Payroll processed successfully.", "success");
// //             fetchCycle();
// //         } catch (err) {
// //             Swal.fire("Error!", err.response?.data?.message || "Error processing cycle", "error");
// //         }
// //     };

// //     const getStatusBadge = (status) => {
// //         switch (status) {
// //             case 'open':
// //                 return <span className="badge bg-warning">Open</span>;
// //             case 'processed':
// //                 return <span className="badge bg-success">Processed</span>;
// //             case 'closed':
// //                 return <span className="badge bg-secondary">Closed</span>;
// //             default:
// //                 return <span className="badge bg-light text-dark">{status}</span>;
// //         }
// //     };

// //     // Function to fetch employee details
// //     const fetchEmployeeDetails = async (employeeId) => {
// //         try {
// //             const userInfo = JSON.parse(localStorage.getItem("user-info"));
// //             const origin = localStorage.getItem("user-origin");
// //             const token = userInfo?.token;

// //             const response = await axios.get(
// //                 `${process.env.REACT_APP_BACKEND_URL}/api/employee/${employeeId}`,
// //                 {
// //                     headers: {
// //                         Authorization: `Bearer ${token}`,
// //                         "Tenant-Origin": origin
// //                     },
// //                     skipLoader: true
// //                 }
// //             );

// //             setEmployeeDetails(response.data?.data);
// //             // setShowEmployeeModal(true);
// //         } catch (error) {
// //             console.error("Error fetching employee details:", error);
// //             Swal.fire("Error!", "Failed to load employee details", "error");
// //         }
// //     };
// //     useEffect(() => {
// //         if (showEmployeeModal && selectedEmployee) {
// //             fetchEmployeeDetails(selectedEmployee.id);
// //         }
// //     }, [showEmployeeModal, selectedEmployee]);

// //     const handleEmployeeClick = (employee) => {
// //         setSelectedEmployee(employee);
// //         setShowEmployeeModal(true);
// //     };


// //     // Employee Details Modal Component
// //     const EmployeeDetailsModal = () => {
// //         if (!employeeDetails) return null;

// //         // Calculate totals
// //         const totalAllowances = employeeDetails.contract?.allowances?.reduce(
// //             (sum, allowance) => sum + parseFloat(allowance.pivot.amount || 0), 0
// //         ) || 0;

// //         const totalDeductions = employeeDetails.contract?.deductions?.reduce(
// //             (sum, deduction) => sum + parseFloat(deduction.pivot.amount || 0), 0
// //         ) || 0;

// //         const totalLoanDeductions = employeeDetails.loans?.reduce(
// //             (sum, loan) => sum + parseFloat(loan.installment_amount || 0), 0
// //         ) || 0;
// //          const totalOvertimePay = employeeDetails.overtime?.reduce(
// //             (sum, over) => sum + parseFloat(over.amount || 0), 0
// //         ) || 0;

// //         const basicSalary = parseFloat(employeeDetails.contract?.salary || 0);
// //         const netSalary = basicSalary + totalAllowances + totalOvertimePay - totalDeductions - totalLoanDeductions;

// //         return (
// //             <Offcanvas
// //                 show={showEmployeeModal}
// //                 onHide={() => setShowEmployeeModal(false)}
// //                 placement="end"
// //                 style={{ width: "500px" }}
// //                 className="employee-details-offcanvas"
// //             >
// //                 <Offcanvas.Header closeButton className="border-bottom bg-light">
// //                     <Offcanvas.Title>
// //                         <div className="d-flex align-items-center">
// //                             <div>
// //                                 {/* <div className="avatar-title bg-primary text-white rounded-circle display-5 fw-medium">
// //                                     {employeeDetails.first_name?.charAt(0)}{employeeDetails.last_name?.charAt(0)}
// //                                 </div> */}
// //                             </div>
// //                             <div>
// //                                 <h5 className="mb-0">{employeeDetails.first_name} {employeeDetails.last_name}</h5>
// //                                 <p className="text-muted mb-0">{employeeDetails.employee_code} • {employeeDetails.department}</p>
// //                             </div>
// //                         </div>
// //                     </Offcanvas.Title>
// //                 </Offcanvas.Header>
// //                 <Offcanvas.Body className="p-0">

// //                         <div className="h-100 d-flex flex-column">
// //                             {/* Scrollable content */}
// //                             <div className="flex-grow-1" style={{ overflowY: 'auto' }}>
// //                                 {/* Summary Card at the top */}
// //                                 <div className="card bg-light text-primary mb-3 mx-3 mt-3">
// //                                     <div className="card-body py-3">
// //                                         <div className="d-flex justify-content-between align-items-center">
// //                                             <div>
// //                                                 <h6 className="card-title mb-0">Net Salary</h6>
// //                                                 <small>This Month</small>
// //                                             </div>
// //                                             <h4 className="mb-0">{netSalary.toFixed(2)}</h4>
// //                                         </div>
// //                                     </div>
// //                                 </div>
// //                                 <div className="mx-3 mb-3">
// //                                     <h6 className="text-muted mb-3">Employee Details</h6>
// //                                     <div className="card">
// //                                         <div className="card-body py-2">
// //                                             <div className="row small">
// //                                                 <div className="col-6 mb-2">
// //                                                     <span className="text-muted">Job Title</span>
// //                                                     <p className="mb-0 fw-medium">{employeeDetails.job_title || ""}</p>
// //                                                 </div>
// //                                                 <div className="col-6 mb-2">
// //                                                     <span className="text-muted">Department</span>
// //                                                     <p className="mb-0 fw-medium">{employeeDetails.department || ""}</p>
// //                                                 </div>
// //                                                 <div className="col-6 mb-2">
// //                                                     <span className="text-muted">Join Date</span>
// //                                                     <p className="mb-0 fw-medium">{employeeDetails.join_date || ""}</p>
// //                                                 </div>
// //                                                 <div className="col-6 mb-2">
// //                                                     <span className="text-muted">Employment Type</span>
// //                                                     <p className="mb-0 fw-medium">{employeeDetails.employment_type || ""}</p>
// //                                                 </div>
// //                                             </div>
// //                                         </div>
// //                                     </div>
// //                                 </div>
// //                                 {/* Salary Breakdown */}
// //                                 <div className="mx-3 mb-3">
// //                                     <h6 className="text-muted mb-3">Salary Breakdown</h6>

// //                                     <div className="card mb-2">
// //                                         <div className="card-body py-2">
// //                                             <div className="d-flex justify-content-between align-items-center">
// //                                                 <span className="fw-medium">Basic Salary</span>
// //                                                 <span className="text-end">
// //                                                     <div className="fw-semibold">{basicSalary.toFixed(2)}</div>
// //                                                 </span>
// //                                             </div>
// //                                         </div>
// //                                     </div>

// //                                     {/* Allowances */}
// //                                     {employeeDetails.contract?.allowances?.length > 0 && (
// //                                         <div className="card mb-2">
// //                                             <div className="card-body py-2">
// //                                                 <div className="d-flex justify-content-between align-items-center mb-2">
// //                                                     <span className="fw-medium text-success">Allowances</span>
// //                                                     <span className="fw-semibold text-success">+{totalAllowances.toFixed(2)}</span>
// //                                                 </div>
// //                                                 {employeeDetails.contract.allowances.map((allowance, index) => (
// //                                                     <div key={index} className="d-flex justify-content-between align-items-center ps-3 small">
// //                                                         <span>{allowance.name}</span>
// //                                                         <span className="text-success">+{allowance.pivot.amount}</span>
// //                                                     </div>
// //                                                 ))}
// //                                             </div>
// //                                         </div>
// //                                     )}

// //                                     {/* Deductions */}
// //                                     {employeeDetails.contract?.deductions?.length > 0 && (
// //                                         <div className="card mb-2">
// //                                             <div className="card-body py-2">
// //                                                 <div className="d-flex justify-content-between align-items-center mb-2">
// //                                                     <span className="fw-medium text-danger">Deductions</span>
// //                                                     <span className="fw-semibold text-danger">-{totalDeductions.toFixed(2)}</span>
// //                                                 </div>
// //                                                 {employeeDetails.contract.deductions.map((deduction, index) => (
// //                                                     <div key={index} className="d-flex justify-content-between align-items-center ps-3 small">
// //                                                         <span>{deduction.name}</span>
// //                                                         <span className="text-danger">-{deduction.pivot.amount}</span>
// //                                                     </div>
// //                                                 ))}
// //                                             </div>
// //                                         </div>
// //                                     )}

// //                                     {/* Loan Information */}
// //                                     {employeeDetails.loans?.length > 0 && (
// //                                         <div className="card mb-2">
// //                                             <div className="card-body py-2">
// //                                                 <div className="d-flex justify-content-between align-items-center mb-2">
// //                                                     <span className="fw-medium text-danger">Loan Deductions</span>
// //                                                     <span className="fw-semibold text-danger">-{totalLoanDeductions.toFixed(2)}</span>
// //                                                 </div>
// //                                                 {employeeDetails.loans.map((loan, index) => (
// //                                                     <div key={index} className="mb-2 ps-3">
// //                                                         <div className="d-flex justify-content-between align-items-center">
// //                                                             <div>
// //                                                                 <span className="fw-medium">{loan.title}</span>
// //                                                                 <span className={`badge ${loan.status === 'approved' ? 'bg-success' : 'bg-warning'} ms-2`}>
// //                                                                     {loan.status}
// //                                                                 </span>
// //                                                             </div>
// //                                                             <span className="text-danger">-{loan.installment_amount}</span>
// //                                                         </div>
// //                                                         <div className="d-flex justify-content-between small text-muted ps-3">
// //                                                             <span>Balance: {loan.balance_amount}</span>
// //                                                             <span>Total: {loan.loan_amount}</span>
// //                                                         </div>
// //                                                     </div>
// //                                                 ))}
// //                                             </div>
// //                                         </div>
// //                                     )}
// //                                      {employeeDetails.overtime?.length > 0 && (
// //                                         <div className="card mb-2">
// //                                             <div className="card-body py-2">
// //                                                 <div className="d-flex justify-content-between align-items-center mb-2">
// //                                                     <span className="fw-medium text-danger">Overtime Details</span>
// //                                                     <span className="fw-semibold text-danger">+{totalOvertimePay.toFixed(2)}</span>
// //                                                 </div>
// //                                                 {employeeDetails.overtime.map((loan, index) => (
// //                                                     <div key={index} className="mb-2 ps-3">
// //                                                         <div className="d-flex justify-content-between align-items-center">
// //                                                             <div>
// //                                                                 <span className="fw-medium">{loan.overtime_type.name}</span>
// //                                                                 {/* <span className={`badge ${loan.status === 'approved' ? 'bg-success' : 'bg-warning'} ms-2`}>
// //                                                                     {loan.status}
// //                                                                 </span> */}
// //                                                             </div>
// //                                                             <span className="text-danger">+{loan.amount}</span>
// //                                                         </div>
// //                                                         {/* <div className="d-flex justify-content-between small text-muted ps-3">
// //                                                             <span>Total: {loan.overtime_pay}</span>
// //                                                         </div> */}
// //                                                     </div>
// //                                                 ))}
// //                                             </div>
// //                                         </div>
// //                                     )}
// //                                 </div>

// //                                 {/* Basic Information */}

// //                             </div>

// //                             {/* Fixed footer with summary */}
// //                             <div className="border-top p-3 bg-light">
// //                                 <div className="d-flex justify-content-between align-items-center">
// //                                     <span className="fw-semibold">Total Earnings:</span>
// //                                     <span className="fw-bold text-success">{(basicSalary + totalAllowances+totalOvertimePay).toFixed(2)}</span>
// //                                 </div>
// //                                 <div className="d-flex justify-content-between align-items-center">
// //                                     <span className="fw-semibold">Total Deductions:</span>
// //                                     <span className="fw-bold text-danger">{(totalDeductions + totalLoanDeductions).toFixed(2)}</span>
// //                                 </div>
// //                                 <div className="d-flex justify-content-between align-items-center pt-2 border-top mt-2">
// //                                     <span className="fw-bold">Net Salary:</span>
// //                                     <span className="fw-bold fs-5 text-primary">{netSalary.toFixed(2)}</span>
// //                                 </div>
// //                             </div>
// //                         </div>

// //                 </Offcanvas.Body>
// //             </Offcanvas>
// //         );
// //     };

// //      const PayrollCycleCard = () => {
// //         const totalGross = payslips.reduce((sum, p) => sum + parseFloat(p.gross_salary || 0), 0);
// //         const totalNet = payslips.reduce((sum, p) => sum + parseFloat(p.net_salary || 0), 0);
// //         const totalDeductions = totalGross - totalNet;

// //         return (
// //             <Card className="mb-4">
// //                 <Card.Header className="bg-light">
// //                     <div className="d-flex justify-content-between align-items-center">
// //                         <h5 className="card-title mb-0">
// //                             {months.find((m) => m.value === cycle.month)?.label} {cycle.year} Payroll
// //                         </h5>
// //                         <Badge bg={
// //                             cycle.status === 'open' ? 'warning' :
// //                                 cycle.status === 'processed' ? 'success' : 'secondary'
// //                         }>
// //                             {cycle.status?.toUpperCase()}
// //                         </Badge>
// //                     </div>
// //                 </Card.Header>
// //                 <Card.Body>
// //                     <Row>
// //                         <Col md={3} sm={6} className="mb-3">
// //                             <div className="text-center">
// //                                 <div className="p-3 border rounded">
// //                                     <h4 className="text-primary mb-1">{payslips.length}</h4>
// //                                     <p className="text-muted mb-0">Employees</p>
// //                                 </div>
// //                             </div>
// //                         </Col>
// //                         <Col md={3} sm={6} className="mb-3">
// //                             <div className="text-center">
// //                                 <div className="p-3 border rounded">
// //                                     <h4 className="text-success mb-1">{totalGross.toFixed(2)}</h4>
// //                                     <p className="text-muted mb-0">Total Gross</p>
// //                                 </div>
// //                             </div>
// //                         </Col>
// //                         <Col md={3} sm={6} className="mb-3">
// //                             <div className="text-center">
// //                                 <div className="p-3 border rounded">
// //                                     <h4 className="text-danger mb-1">{totalDeductions.toFixed(2)}</h4>
// //                                     <p className="text-muted mb-0">Total Deductions</p>
// //                                 </div>
// //                             </div>
// //                         </Col>
// //                         <Col md={3} sm={6} className="mb-3">
// //                             <div className="text-center">
// //                                 <div className="p-3 border rounded bg-light">
// //                                     <h4 className="text-primary mb-1">{totalNet.toFixed(2)}</h4>
// //                                     <p className="text-muted mb-0">Net Payroll</p>
// //                                 </div>
// //                             </div>
// //                         </Col>
// //                     </Row>

// //                     {/* <div className="d-flex gap-2 justify-content-center mt-3">
// //                         <Button variant="outline-primary" size="sm">
// //                             <FaDownload className="me-1" /> Export
// //                         </Button>
// //                         <Button variant="outline-info" size="sm">
// //                             <FaEye className="me-1" /> Details
// //                         </Button>
// //                         {cycle.status === "open" && (
// //                             <Button
// //                                 variant="primary"
// //                                 onClick={handleProcessCycle}
// //                                 size="sm"
// //                             >
// //                                 <FaCog className="me-1" /> Process Payroll
// //                             </Button>
// //                         )}
// //                     </div> */}
// //                 </Card.Body>
// //             </Card>
// //         );
// //     };

// //     // Improved table with better styling
// //     const updatedPayslipsTable = (
// //         <Card>
// //             <Card.Header className="bg-light">
// //                 <h5 className="card-title mb-0">Payslips Details</h5>
// //             </Card.Header>
// //             <Card.Body>
// //                 <div className="table-responsive">
// //                     <table className="table align-middle table-nowrap table-check table-list">
// //                         <thead className="table-light">
// //                             <tr>
// //                                 <th className='align-middle'>Employee</th>
// //                                 <th className="text-end">Basic</th>
// //                                 <th className="text-end">Allowances</th>
// //                                 <th className="text-end">Deductions</th>
// //                                 <th className="text-end">Loan</th>
// //                                 <th className='text-end'>Overtime</th>
// //                                 <th className="text-end">Gross</th>
// //                                 <th className="text-end">Net</th>
// //                             </tr>
// //                         </thead>
// //                         <tbody>
// //                             {payslips.map((p) => (
// //                                 <tr key={p.id} className="cursor-pointer" onClick={() => handleEmployeeClick(p.employee)}>
// //                                     <td className='align-middle'>
// //                                         {/* <div className="avatar-xs rounded-circle bg-primary text-white d-flex align-items-center justify-content-center me-2">
// //                                                 {(p.employee?.first_name?.charAt(0) || '')}
// //                                                 {(p.employee?.last_name?.charAt(0) || '')}
// //                                             </div> */}
// //                                         <div>
// //                                             {p.employee.first_name} {p.employee.last_name}
// //                                         </div>

// //                                     </td>
// //                                     <td className="text-end">{parseFloat(p.basic || 0).toFixed(2)}</td>
// //                                     <td className="text-end text-success">{parseFloat(p.total_allowances || 0).toFixed(2)}</td>
// //                                     <td className="text-end text-danger">{parseFloat(p.total_deductions || 0).toFixed(2)}</td>
// //                                     <td className="text-end text-danger">{parseFloat(p.loan_deduction || 0).toFixed(2)}</td>
// //                                     <td className="text-end text-danger">{parseFloat(p.overtime_pay || 0).toFixed(2)}</td>

// //                                     <td className="text-end fw-semibold">{parseFloat(p.gross_salary || 0).toFixed(2)}</td>
// //                                     <td className="text-end fw-bold text-primary">{parseFloat(p.net_salary || 0).toFixed(2)}</td>
// //                                 </tr>
// //                             ))}
// //                         </tbody>
// //                         {payslips.length > 0 && (
// //                             <tfoot className="table-group-divider">
// //                                 <tr className="fw-bold">
// //                                     <td>Totals</td>
// //                                     <td className="text-end">{payslips.reduce((sum, p) => sum + parseFloat(p.basic || 0), 0).toFixed(2)}</td>
// //                                     <td className="text-end text-success">{payslips.reduce((sum, p) => sum + parseFloat(p.total_allowances || 0), 0).toFixed(2)}</td>
// //                                     <td className="text-end text-danger">{payslips.reduce((sum, p) => sum + parseFloat(p.total_deductions || 0), 0).toFixed(2)}</td>
// //                                     <td className="text-end text-danger">{payslips.reduce((sum, p) => sum + parseFloat(p.loan_deduction || 0), 0).toFixed(2)}</td>
// //                                     <td className="text-end text-danger">{payslips.reduce((sum, p) => sum + parseFloat(p.overtime_pay || 0), 0).toFixed(2)}</td>

// //                                     <td className="text-end">{payslips.reduce((sum, p) => sum + parseFloat(p.gross_salary || 0), 0).toFixed(2)}</td>
// //                                     <td className="text-end text-primary">{payslips.reduce((sum, p) => sum + parseFloat(p.net_salary || 0), 0).toFixed(2)}</td>
// //                                 </tr>
// //                             </tfoot>
// //                         )}
// //                     </table>
// //                 </div>
// //             </Card.Body>
// //         </Card>
// //     );

// //     return (
// //         <div className="main-content">
// //             <div className="page-content">
// //                 <div className="container-fluid">
// //                     <div className="row">
// //                         <div className="col-12">
// //                             <div className="page-title-box d-sm-flex align-items-center justify-content-between">
// //                                 <h4 className="mb-sm-0 font-size-18">Payroll Cycles</h4>
// //                                 <div className="page-title-right">
// //                                     <ol className="breadcrumb m-0">
// //                                         <li className="breadcrumb-item"><a href="#">Payroll</a></li>
// //                                         <li className="breadcrumb-item active">Cycles</li>
// //                                     </ol>
// //                                 </div>
// //                             </div>
// //                         </div>
// //                     </div>

// //                     <Row>
// //                         <Col lg={12}>
// //                             <Card>
// //                                 <Card.Body>
// //                                     <div className="d-flex justify-content-between align-items-center mb-3">
// //                                         <h4 className="card-title mb-0">Payroll Cycle Management</h4>
// //                                         <div>
// //                                             <Button
// //                                                 variant="outline-secondary"
// //                                                 onClick={() => setShowFilters(!showFilters)}
// //                                             >
// //                                                 <FaFilter className="me-1" /> Filters
// //                                             </Button>
// //                                         </div>
// //                                     </div>

// //                                     {/* Filters Section */}
// //                                     {showFilters && (
// //                                         <Row className="mb-3 p-3 border rounded">
// //                                             <Col md={4}>
// //                                                 <div className="mb-3">
// //                                                     <label className="form-label">Month</label>
// //                                                     <select
// //                                                         className="form-select"
// //                                                         value={month}
// //                                                         onChange={(e) => setMonth(parseInt(e.target.value))}
// //                                                     >
// //                                                         {months.map((m) => (
// //                                                             <option key={m.value} value={m.value}>
// //                                                                 {m.label}
// //                                                             </option>
// //                                                         ))}
// //                                                     </select>
// //                                                 </div>
// //                                             </Col>
// //                                             <Col md={4}>
// //                                                 <div className="mb-3">
// //                                                     <label className="form-label">Year</label>
// //                                                     <select
// //                                                         className="form-select"
// //                                                         value={year}
// //                                                         onChange={(e) => setYear(parseInt(e.target.value))}
// //                                                     >
// //                                                         {years.map((y) => (
// //                                                             <option key={y} value={y}>
// //                                                                 {y}
// //                                                             </option>
// //                                                         ))}
// //                                                     </select>
// //                                                 </div>
// //                                             </Col>
// //                                             <Col md={4}>
// //                                                 <div className="mb-3">
// //                                                     <label className="form-label">Status</label>
// //                                                     <select className="form-select">
// //                                                         <option value="">All Statuses</option>
// //                                                         <option value="open">Open</option>
// //                                                         <option value="processed">Processed</option>
// //                                                         <option value="closed">Closed</option>
// //                                                     </select>
// //                                                 </div>
// //                                             </Col>
// //                                             <Col md={12} className="d-flex justify-content-end">
// //                                                 <Button variant="outline-secondary" className="me-2">
// //                                                     Clear
// //                                                 </Button>
// //                                                 <Button variant="primary">
// //                                                     Apply Filters
// //                                                 </Button>
// //                                             </Col>
// //                                         </Row>
// //                                     )}

// //                                     {/* Search Box */}
// //                                     <Row className="mb-3">
// //                                         <Col md={6}>
// //                                             <div className="search-box me-2 mb-2 d-inline-block w-100">
// //                                                 <div className="position-relative">
// //                                                     <input
// //                                                         type="text"
// //                                                         className="form-control"
// //                                                         placeholder="Search cycles..."
// //                                                         value={searchQuery}
// //                                                         onChange={(e) => setSearchQuery(e.target.value)}
// //                                                     />
// //                                                     <FaSearch className="search-icon" />
// //                                                 </div>
// //                                             </div>
// //                                         </Col>
// //                                     </Row>

// //                                     {/* Cycle Controls */}
// //                                     <Row className="mb-4">
// //                                         <Col md={12}>
// //                                             <Card className="bg-light">
// //                                                 <Card.Body className="py-2">
// //                                                     <div className="d-flex justify-content-between align-items-center">
// //                                                         <div>
// //                                                             <h6 className="mb-0">Current Selection: {months.find((m) => m.value === month)?.label} {year}</h6>
// //                                                         </div>
// //                                                         <div>
// //                                                             {!cycle ? (
// //                                                                 <Button variant="success" onClick={handleCreateCycle}>
// //                                                                     Create Cycle
// //                                                                 </Button>
// //                                                             ) : cycle.status === "open" ? (
// //                                                                 <Button variant="primary" onClick={handleProcessCycle}>
// //                                                                     Process Payroll
// //                                                                 </Button>
// //                                                             ) : (
// //                                                                 <span className="text-success fw-bold">Payslips generated ✅</span>
// //                                                             )}
// //                                                         </div>
// //                                                     </div>
// //                                                 </Card.Body>
// //                                             </Card>
// //                                         </Col>
// //                                     </Row>

// //                                         {/* <div className="text-center py-4">
// //                                             <div className="spinner-border text-primary" role="status">
// //                                                 <span className="visually-hidden">Loading...</span>
// //                                             </div>
// //                                         </div> */}
// //                                     { cycle ? (
// //                                         <>
// //                                             <PayrollCycleCard />
// //                                             {payslips.length > 0 && updatedPayslipsTable}
// //                                         </>
// //                                     ) : (
// //                                         <div className="text-center py-5">
// //                                             <div className="avatar-md mx-auto mb-4">
// //                                                 <div className="avatar-title bg-primary-subtle text-primary rounded-circle display-5">
// //                                                     <i className="bx bx-calendar"></i>
// //                                                 </div>
// //                                             </div>
// //                                             <h5>No Payroll Cycle Found</h5>
// //                                             <p className="text-muted">Create a new payroll cycle for {months.find((m) => m.value === month)?.label} {year}</p>
// //                                             <Button variant="primary" onClick={handleCreateCycle}>
// //                                                 Create New Cycle
// //                                             </Button>
// //                                         </div>
// //                                     )}

// //                                     {/* Pagination */}
// //                                     <div className="d-flex justify-content-between align-items-center mt-3">
// //                                         <div>
// //                                             Showing {payslips.length} entries
// //                                         </div>
// //                                         <ReactPaginate
// //                                             previousLabel={"<"}
// //                                             nextLabel={">"}
// //                                             breakLabel={"..."}
// //                                             pageCount={pageCount}
// //                                             marginPagesDisplayed={2}
// //                                             pageRangeDisplayed={3}
// //                                             onPageChange={handlePageChange}
// //                                             containerClassName={"pagination pagination-rounded mb-0"}
// //                                             pageClassName={"page-item"}
// //                                             pageLinkClassName={"page-link"}
// //                                             previousClassName={"page-item"}
// //                                             previousLinkClassName={"page-link"}
// //                                             nextClassName={"page-item"}
// //                                             nextLinkClassName={"page-link"}
// //                                             breakClassName={"page-item"}
// //                                             breakLinkClassName={"page-link"}
// //                                             activeClassName={"active"}
// //                                         />
// //                                     </div>
// //                                 </Card.Body>
// //                             </Card>
// //                         </Col>
// //                     </Row>

// //                     <EmployeeDetailsModal />
// //                 </div>
// //             </div>
// //         </div>
// //     );
// // };

// // const PayrollCycleList = () => {
// //     const [employees, setEmployees] = useState([]);
// //     const [selectedEmployee, setSelectedEmployee] = useState(null);
// //     const [month, setMonth] = useState(new Date().getMonth() + 1);
// //     const [year, setYear] = useState(new Date().getFullYear());
// //     const [payrollData, setPayrollData] = useState({
// //         basicSalary: 0,
// //         allowances: [],
// //         deductions: [],
// //         loans: [],
// //         overtime: [],
// //         bonuses: [],
// //         grossSalary: 0,
// //         totalDeductions: 0,
// //         netSalary: 0
// //     });
// //     const [showDeductionModal, setShowDeductionModal] = useState(false);
// //     const [showBonusModal, setShowBonusModal] = useState(false);
// //     const [showOvertimeModal, setShowOvertimeModal] = useState(false);
// //     const [showLoanModal, setShowLoanModal] = useState(false);
// //     const [newDeduction, setNewDeduction] = useState({ name: '', amount: 0 });
// //     const [newBonus, setNewBonus] = useState({ name: '', amount: 0 });
// //     const [newOvertime, setNewOvertime] = useState({ hours: 0, rate: 0, amount: 0 });
// //     const [newLoan, setNewLoan] = useState({ title: '', amount: 0, installment: 0 });

// //     const token = JSON.parse(localStorage.getItem("user-info"))?.token;
// //     const origin = localStorage.getItem("user-origin");

// //     const months = [
// //         { value: 1, label: "January" },
// //         { value: 2, label: "February" },
// //         { value: 3, label: "March" },
// //         { value: 4, label: "April" },
// //         { value: 5, label: "May" },
// //         { value: 6, label: "June" },
// //         { value: 7, label: "July" },
// //         { value: 8, label: "August" },
// //         { value: 9, label: "September" },
// //         { value: 10, label: "October" },
// //         { value: 11, label: "November" },
// //         { value: 12, label: "December" }
// //     ];

// //     const years = Array.from({ length: 10 }, (_, i) => new Date().getFullYear() - 5 + i);

// //     // Fetch employees
// //     useEffect(() => {
// //         fetchEmployees();
// //     }, []);

// //     const fetchEmployees = async () => {
// //         try {
// //             const res = await axios.get(
// //                 `${process.env.REACT_APP_BACKEND_URL}/api/employee`,
// //                 { headers: { Authorization: `Bearer ${token}`, "Tenant-Origin": origin } }
// //             );
// //             setEmployees(res.data.data || []);
// //         } catch (err) {
// //             console.error("Error fetching employees:", err);
// //             Swal.fire("Error!", "Failed to load employees", "error");
// //         }
// //     };

// //     // Fetch employee details when selected
// //     useEffect(() => {
// //         if (selectedEmployee) {
// //             fetchEmployeeDetails(selectedEmployee);
// //         }
// //     }, [selectedEmployee, month, year]);

// //     const fetchEmployeeDetails = async (employeeId) => {
// //         try {
// //             const response = await axios.get(
// //                 `${process.env.REACT_APP_BACKEND_URL}/api/employee/${employeeId}`,
// //                 { headers: { Authorization: `Bearer ${token}`, "Tenant-Origin": origin } }
// //             );

// //             const employeeData = response.data?.data;
// //             if (employeeData) {
// //                 // Calculate basic salary
// //                 const basicSalary = parseFloat(employeeData.contract?.salary || 0);

// //                 // Get allowances from contract
// //                 const allowances = employeeData.contract?.allowances?.map(a => ({
// //                     id: a.id,
// //                     name: a.name,
// //                     amount: parseFloat(a.pivot.amount || 0)
// //                 })) || [];

// //                 // Get deductions from contract
// //                 const deductions = employeeData.contract?.deductions?.map(d => ({
// //                     id: d.id,
// //                     name: d.name,
// //                     amount: parseFloat(d.pivot.amount || 0)
// //                 })) || [];

// //                 // Get active loans
// //                 const loans = employeeData.loans?.filter(l => l.status === 'approved').map(l => ({
// //                     id: l.id,
// //                     title: l.title,
// //                     amount: parseFloat(l.installment_amount || 0)
// //                 })) || [];

// //                 // Get overtime for selected month/year
// //                 const overtime = employeeData.overtime?.filter(ot => {
// //                     const otDate = new Date(ot.date);
// //                     return otDate.getMonth() + 1 === month && otDate.getFullYear() === year;
// //                 }).map(ot => ({
// //                     id: ot.id,
// //                     type: ot.overtime_type?.name,
// //                     hours: ot.hours,
// //                     rate: ot.rate,
// //                     amount: parseFloat(ot.amount || 0)
// //                 })) || [];

// //                 // Calculate totals
// //                 const totalAllowances = allowances.reduce((sum, a) => sum + a.amount, 0);
// //                 const totalDeductions = deductions.reduce((sum, d) => sum + d.amount, 0);
// //                 const totalLoans = loans.reduce((sum, l) => sum + l.amount, 0);
// //                 const totalOvertime = overtime.reduce((sum, ot) => sum + ot.amount, 0);

// //                 const grossSalary = basicSalary + totalAllowances + totalOvertime;
// //                 const totalDeductionsAll = totalDeductions + totalLoans;
// //                 const netSalary = grossSalary - totalDeductionsAll;

// //                 setPayrollData({
// //                     basicSalary,
// //                     allowances,
// //                     deductions,
// //                     loans,
// //                     overtime,
// //                     bonuses: [],
// //                     grossSalary,
// //                     totalDeductions: totalDeductionsAll,
// //                     netSalary
// //                 });
// //             }
// //         } catch (error) {
// //             console.error("Error fetching employee details:", error);
// //             Swal.fire("Error!", "Failed to load employee details", "error");
// //         }
// //     };

// //     // Handler for adding a new deduction
// //     const handleAddDeduction = () => {
// //         if (!newDeduction.name || newDeduction.amount <= 0) {
// //             Swal.fire("Error!", "Please enter a valid name and amount", "error");
// //             return;
// //         }

// //         const updatedDeductions = [...payrollData.deductions, {
// //             id: Date.now(), // temporary ID
// //             name: newDeduction.name,
// //             amount: parseFloat(newDeduction.amount)
// //         }];

// //         updatePayrollData(updatedDeductions, 'deductions');
// //         setNewDeduction({ name: '', amount: 0 });
// //         setShowDeductionModal(false);
// //     };

// //     // Handler for adding a new bonus
// //     const handleAddBonus = () => {
// //         if (!newBonus.name || newBonus.amount <= 0) {
// //             Swal.fire("Error!", "Please enter a valid name and amount", "error");
// //             return;
// //         }

// //         const updatedBonuses = [...payrollData.bonuses, {
// //             id: Date.now(), // temporary ID
// //             name: newBonus.name,
// //             amount: parseFloat(newBonus.amount)
// //         }];

// //         updatePayrollData(updatedBonuses, 'bonuses');
// //         setNewBonus({ name: '', amount: 0 });
// //         setShowBonusModal(false);
// //     };

// //     // Handler for adding overtime
// //     const handleAddOvertime = () => {
// //         if (newOvertime.hours <= 0 || newOvertime.rate <= 0) {
// //             Swal.fire("Error!", "Please enter valid hours and rate", "error");
// //             return;
// //         }

// //         const amount = newOvertime.hours * newOvertime.rate;
// //         const updatedOvertime = [...payrollData.overtime, {
// //             id: Date.now(), // temporary ID
// //             type: "Manual Entry",
// //             hours: newOvertime.hours,
// //             rate: newOvertime.rate,
// //             amount: amount
// //         }];

// //         updatePayrollData(updatedOvertime, 'overtime');
// //         setNewOvertime({ hours: 0, rate: 0, amount: 0 });
// //         setShowOvertimeModal(false);
// //     };

// //     // Handler for adding a loan deduction
// //     const handleAddLoan = () => {
// //         if (!newLoan.title || newLoan.amount <= 0) {
// //             Swal.fire("Error!", "Please enter a valid title and amount", "error");
// //             return;
// //         }

// //         const updatedLoans = [...payrollData.loans, {
// //             id: Date.now(), // temporary ID
// //             title: newLoan.title,
// //             amount: parseFloat(newLoan.amount)
// //         }];

// //         updatePayrollData(updatedLoans, 'loans');
// //         setNewLoan({ title: '', amount: 0, installment: 0 });
// //         setShowLoanModal(false);
// //     };

// //     // Update payroll data when any component changes
// //     const updatePayrollData = (updatedItems, field) => {
// //         const updatedData = { ...payrollData, [field]: updatedItems };

// //         // Recalculate totals
// //         const totalAllowances = updatedData.allowances.reduce((sum, a) => sum + a.amount, 0);
// //         const totalDeductions = updatedData.deductions.reduce((sum, d) => sum + d.amount, 0);
// //         const totalLoans = updatedData.loans.reduce((sum, l) => sum + l.amount, 0);
// //         const totalOvertime = updatedData.overtime.reduce((sum, ot) => sum + ot.amount, 0);
// //         const totalBonuses = updatedData.bonuses.reduce((sum, b) => sum + b.amount, 0);

// //         updatedData.grossSalary = updatedData.basicSalary + totalAllowances + totalOvertime + totalBonuses;
// //         updatedData.totalDeductions = totalDeductions + totalLoans;
// //         updatedData.netSalary = updatedData.grossSalary - updatedData.totalDeductions;

// //         setPayrollData(updatedData);
// //     };

// //     // Remove an item from payroll components
// //     const removeItem = (id, field) => {
// //         const updatedItems = payrollData[field].filter(item => item.id !== id);
// //         updatePayrollData(updatedItems, field);
// //     };

// //     // Submit payroll data
// //     const handleSubmitPayroll = async () => {
// //         if (!selectedEmployee) {
// //             Swal.fire("Error!", "Please select an employee", "error");
// //             return;
// //         }

// //         try {
// //             const payload = {
// //                 employee_id: selectedEmployee,
// //                 month: month,
// //                 year: year,
// //                 basic_salary: payrollData.basicSalary,
// //                 allowances: payrollData.allowances,
// //                 deductions: payrollData.deductions,
// //                 loans: payrollData.loans,
// //                 overtime: payrollData.overtime,
// //                 bonuses: payrollData.bonuses,
// //                 gross_salary: payrollData.grossSalary,
// //                 total_deductions: payrollData.totalDeductions,
// //                 net_salary: payrollData.netSalary
// //             };

// //             const res = await axios.post(
// //                 `${process.env.REACT_APP_BACKEND_URL}/api/payroll`,
// //                 payload,
// //                 { headers: { Authorization: `Bearer ${token}`, "Tenant-Origin": origin } }
// //             );

// //             Swal.fire("Success!", "Payroll data saved successfully", "success");
// //         } catch (error) {
// //             console.error("Error saving payroll:", error);
// //             Swal.fire("Error!", "Failed to save payroll data", "error");
// //         }
// //     };

// //     // Modal components
// //     const DeductionModal = () => (
// //         <Modal show={showDeductionModal} onHide={() => setShowDeductionModal(false)}>
// //             <Modal.Header closeButton>
// //                 <Modal.Title>Add Deduction</Modal.Title>
// //             </Modal.Header>
// //             <Modal.Body>
// //                 <Form.Group className="mb-3">
// //                     <Form.Label>Deduction Name</Form.Label>
// //                     <Form.Control
// //                         type="text"
// //                         value={newDeduction.name}
// //                         onChange={(e) => setNewDeduction({ ...newDeduction, name: e.target.value })}
// //                         placeholder="Enter deduction name"
// //                     />
// //                 </Form.Group>
// //                 <Form.Group className="mb-3">
// //                     <Form.Label>Amount</Form.Label>
// //                     <Form.Control
// //                         type="number"
// //                         value={newDeduction.amount}
// //                         onChange={(e) => setNewDeduction({ ...newDeduction, amount: parseFloat(e.target.value) || 0 })}
// //                         placeholder="Enter amount"
// //                     />
// //                 </Form.Group>
// //             </Modal.Body>
// //             <Modal.Footer>
// //                 <Button variant="secondary" onClick={() => setShowDeductionModal(false)}>
// //                     Cancel
// //                 </Button>
// //                 <Button variant="primary" onClick={handleAddDeduction}>
// //                     Add Deduction
// //                 </Button>
// //             </Modal.Footer>
// //         </Modal>
// //     );

// //     const BonusModal = () => (
// //         <Modal show={showBonusModal} onHide={() => setShowBonusModal(false)}>
// //             <Modal.Header closeButton>
// //                 <Modal.Title>Add Bonus</Modal.Title>
// //             </Modal.Header>
// //             <Modal.Body>
// //                 <Form.Group className="mb-3">
// //                     <Form.Label>Bonus Name</Form.Label>
// //                     <Form.Control
// //                         type="text"
// //                         value={newBonus.name}
// //                         onChange={(e) => setNewBonus({ ...newBonus, name: e.target.value })}
// //                         placeholder="Enter bonus name"
// //                     />
// //                 </Form.Group>
// //                 <Form.Group className="mb-3">
// //                     <Form.Label>Amount</Form.Label>
// //                     <Form.Control
// //                         type="number"
// //                         value={newBonus.amount}
// //                         onChange={(e) => setNewBonus({ ...newBonus, amount: parseFloat(e.target.value) || 0 })}
// //                         placeholder="Enter amount"
// //                     />
// //                 </Form.Group>
// //             </Modal.Body>
// //             <Modal.Footer>
// //                 <Button variant="secondary" onClick={() => setShowBonusModal(false)}>
// //                     Cancel
// //                 </Button>
// //                 <Button variant="primary" onClick={handleAddBonus}>
// //                     Add Bonus
// //                 </Button>
// //             </Modal.Footer>
// //         </Modal>
// //     );

// //     const OvertimeModal = () => (
// //         <Modal show={showOvertimeModal} onHide={() => setShowOvertimeModal(false)}>
// //             <Modal.Header closeButton>
// //                 <Modal.Title>Add Overtime</Modal.Title>
// //             </Modal.Header>
// //             <Modal.Body>
// //                 <Form.Group className="mb-3">
// //                     <Form.Label>Hours</Form.Label>
// //                     <Form.Control
// //                         type="number"
// //                         step="0.5"
// //                         value={newOvertime.hours}
// //                         onChange={(e) => setNewOvertime({ ...newOvertime, hours: parseFloat(e.target.value) || 0 })}
// //                         placeholder="Enter hours"
// //                     />
// //                 </Form.Group>
// //                 <Form.Group className="mb-3">
// //                     <Form.Label>Rate per Hour</Form.Label>
// //                     <Form.Control
// //                         type="number"
// //                         value={newOvertime.rate}
// //                         onChange={(e) => setNewOvertime({ ...newOvertime, rate: parseFloat(e.target.value) || 0 })}
// //                         placeholder="Enter rate"
// //                     />
// //                 </Form.Group>
// //                 <Form.Group className="mb-3">
// //                     <Form.Label>Total Amount: {newOvertime.hours * newOvertime.rate}</Form.Label>
// //                 </Form.Group>
// //             </Modal.Body>
// //             <Modal.Footer>
// //                 <Button variant="secondary" onClick={() => setShowOvertimeModal(false)}>
// //                     Cancel
// //                 </Button>
// //                 <Button variant="primary" onClick={handleAddOvertime}>
// //                     Add Overtime
// //                 </Button>
// //             </Modal.Footer>
// //         </Modal>
// //     );

// //     const LoanModal = () => (
// //         <Modal show={showLoanModal} onHide={() => setShowLoanModal(false)}>
// //             <Modal.Header closeButton>
// //                 <Modal.Title>Add Loan Deduction</Modal.Title>
// //             </Modal.Header>
// //             <Modal.Body>
// //                 <Form.Group className="mb-3">
// //                     <Form.Label>Loan Title</Form.Label>
// //                     <Form.Control
// //                         type="text"
// //                         value={newLoan.title}
// //                         onChange={(e) => setNewLoan({ ...newLoan, title: e.target.value })}
// //                         placeholder="Enter loan title"
// //                     />
// //                 </Form.Group>
// //                 <Form.Group className="mb-3">
// //                     <Form.Label>Deduction Amount</Form.Label>
// //                     <Form.Control
// //                         type="number"
// //                         value={newLoan.amount}
// //                         onChange={(e) => setNewLoan({ ...newLoan, amount: parseFloat(e.target.value) || 0 })}
// //                         placeholder="Enter amount"
// //                     />
// //                 </Form.Group>
// //             </Modal.Body>
// //             <Modal.Footer>
// //                 <Button variant="secondary" onClick={() => setShowLoanModal(false)}>
// //                     Cancel
// //                 </Button>
// //                 <Button variant="primary" onClick={handleAddLoan}>
// //                     Add Loan Deduction
// //                 </Button>
// //             </Modal.Footer>
// //         </Modal>
// //     );

// //     return (
// //         <div className="main-content">
// //             <div className="page-content">
// //                 <div className="container-fluid">
// //                     <div className="row">
// //                         <div className="col-12">
// //                             <div className="page-title-box d-sm-flex align-items-center justify-content-between">
// //                                 <h4 className="mb-sm-0 font-size-18">Payroll Form</h4>
// //                                 <div className="page-title-right">
// //                                     <ol className="breadcrumb m-0">
// //                                         <li className="breadcrumb-item"><a href="#">Payroll</a></li>
// //                                         <li className="breadcrumb-item active">Create Payroll</li>
// //                                     </ol>
// //                                 </div>
// //                             </div>
// //                         </div>
// //                     </div>

// //                     <Row>
// //                         <Col lg={12}>
// //                             <Card>
// //                                 <Card.Body>
// //                                     <h4 className="card-title mb-4">Create Payroll</h4>

// //                                     <Row className="mb-3">
// //                                         <Col md={4}>
// //                                             <Form.Group>
// //                                                 <Form.Label>Select Employee</Form.Label>
// //                                                 <Form.Select
// //                                                     value={selectedEmployee || ''}
// //                                                     onChange={(e) => setSelectedEmployee(e.target.value)}
// //                                                 >
// //                                                     <option value="">Select Employee</option>
// //                                                     {employees.map(emp => (
// //                                                         <option key={emp.id} value={emp.id}>
// //                                                             {emp.first_name} {emp.last_name} ({emp.employee_code})
// //                                                         </option>
// //                                                     ))}
// //                                                 </Form.Select>
// //                                             </Form.Group>
// //                                         </Col>
// //                                         <Col md={4}>
// //                                             <Form.Group>
// //                                                 <Form.Label>Month</Form.Label>
// //                                                 <Form.Select
// //                                                     value={month}
// //                                                     onChange={(e) => setMonth(parseInt(e.target.value))}
// //                                                 >
// //                                                     {months.map(m => (
// //                                                         <option key={m.value} value={m.value}>
// //                                                             {m.label}
// //                                                         </option>
// //                                                     ))}
// //                                                 </Form.Select>
// //                                             </Form.Group>
// //                                         </Col>
// //                                         <Col md={4}>
// //                                             <Form.Group>
// //                                                 <Form.Label>Year</Form.Label>
// //                                                 <Form.Select
// //                                                     value={year}
// //                                                     onChange={(e) => setYear(parseInt(e.target.value))}
// //                                                 >
// //                                                     {years.map(y => (
// //                                                         <option key={y} value={y}>
// //                                                             {y}
// //                                                         </option>
// //                                                     ))}
// //                                                 </Form.Select>
// //                                             </Form.Group>
// //                                         </Col>
// //                                     </Row>

// //                                     {selectedEmployee && (
// //                                         <>
// //                                             <Row className="mb-4">
// //                                                 <Col md={12}>
// //                                                     <Card className="bg-gradient bg-white text-primary shadow-sm">
// //                                                         <Card.Body className="d-flex flex-column flex-md-row align-items-center justify-content-between">
// //                                                             <div>
// //                                                                 <h5 className="mb-2">Net Salary</h5>
// //                                                                 <h2 className="mb-0 fw-bold">AED {payrollData.netSalary.toFixed(2)}</h2>
// //                                                                 <div className="small mt-2">
// //                                                                     Gross: AED {payrollData.grossSalary.toFixed(2)} &nbsp; | &nbsp;
// //                                                                     Deductions: AED {payrollData.totalDeductions.toFixed(2)}
// //                                                                 </div>
// //                                                             </div>
// //                                                             <div className="mt-3 mt-md-0">
// //                                                                 <Button
// //                                                                     variant="light"
// //                                                                     size="lg"
// //                                                                     className="fw-bold shadow"
// //                                                                     onClick={handleSubmitPayroll}
// //                                                                 >
// //                                                                     💾 Save Payroll
// //                                                                 </Button>
// //                                                             </div>
// //                                                         </Card.Body>
// //                                                     </Card>
// //                                                 </Col>
// //                                             </Row>
// //                                             <Row>
// //                                                 <Col md={6}>
// //                                                     <Card className="bg-light">
// //                                                         <Card.Header>
// //                                                             <h5 className="card-title mb-0">Earnings</h5>
// //                                                         </Card.Header>
// //                                                         <Card.Body>
// //                                                             <div className="d-flex justify-content-between mb-2">
// //                                                                 <span>Basic Salary:</span>
// //                                                                 <span className="fw-semibold">{payrollData.basicSalary.toFixed(2)}</span>
// //                                                             </div>

// //                                                             <div className="mb-3">
// //                                                                 <div className="d-flex justify-content-between align-items-center mb-2">
// //                                                                     <h6 className="mb-0">Allowances</h6>
// //                                                                     <Button
// //                                                                         variant="outline-primary"
// //                                                                         size="sm"
// //                                                                         onClick={() => setShowDeductionModal(true)}
// //                                                                     >
// //                                                                         <FaPlus className="me-1" /> Add
// //                                                                     </Button>
// //                                                                 </div>
// //                                                                 {payrollData.allowances.map((allowance, index) => (
// //                                                                     <div key={index} className="d-flex justify-content-between align-items-center ps-3 small">
// //                                                                         <span>{allowance.name}</span>
// //                                                                         <div>
// //                                                                             <span className="text-success me-2">+{allowance.amount.toFixed(2)}</span>
// //                                                                             <Button
// //                                                                                 variant="link"
// //                                                                                 size="sm"
// //                                                                                 className="text-danger p-0"
// //                                                                                 onClick={() => removeItem(allowance.id, 'allowances')}
// //                                                                             >
// //                                                                                 <FaTimes />
// //                                                                             </Button>
// //                                                                         </div>
// //                                                                     </div>
// //                                                                 ))}
// //                                                                 {payrollData.allowances.length === 0 && (
// //                                                                     <div className="text-muted ps-3 small">No allowances added</div>
// //                                                                 )}
// //                                                             </div>

// //                                                             <div className="mb-3">
// //                                                                 <div className="d-flex justify-content-between align-items-center mb-2">
// //                                                                     <h6 className="mb-0">Overtime</h6>
// //                                                                     <Button
// //                                                                         variant="outline-primary"
// //                                                                         size="sm"
// //                                                                         onClick={() => setShowOvertimeModal(true)}
// //                                                                     >
// //                                                                         <FaPlus className="me-1" /> Add
// //                                                                     </Button>
// //                                                                 </div>
// //                                                                 {payrollData.overtime.map((ot, index) => (
// //                                                                     <div key={index} className="d-flex justify-content-between align-items-center ps-3 small">
// //                                                                         <span>{ot.type} ({ot.hours} hrs)</span>
// //                                                                         <div>
// //                                                                             <span className="text-success me-2">+{ot.amount.toFixed(2)}</span>
// //                                                                             <Button
// //                                                                                 variant="link"
// //                                                                                 size="sm"
// //                                                                                 className="text-danger p-0"
// //                                                                                 onClick={() => removeItem(ot.id, 'overtime')}
// //                                                                             >
// //                                                                                 <FaTimes />
// //                                                                             </Button>
// //                                                                         </div>
// //                                                                     </div>
// //                                                                 ))}
// //                                                                 {payrollData.overtime.length === 0 && (
// //                                                                     <div className="text-muted ps-3 small">No overtime added</div>
// //                                                                 )}
// //                                                             </div>

// //                                                             <div className="mb-3">
// //                                                                 <div className="d-flex justify-content-between align-items-center mb-2">
// //                                                                     <h6 className="mb-0">Bonuses</h6>
// //                                                                     <Button
// //                                                                         variant="outline-primary"
// //                                                                         size="sm"
// //                                                                         onClick={() => setShowBonusModal(true)}
// //                                                                     >
// //                                                                         <FaPlus className="me-1" /> Add
// //                                                                     </Button>
// //                                                                 </div>
// //                                                                 {payrollData.bonuses.map((bonus, index) => (
// //                                                                     <div key={index} className="d-flex justify-content-between align-items-center ps-3 small">
// //                                                                         <span>{bonus.name}</span>
// //                                                                         <div>
// //                                                                             <span className="text-success me-2">+{bonus.amount.toFixed(2)}</span>
// //                                                                             <Button
// //                                                                                 variant="link"
// //                                                                                 size="sm"
// //                                                                                 className="text-danger p-0"
// //                                                                                 onClick={() => removeItem(bonus.id, 'bonuses')}
// //                                                                             >
// //                                                                                 <FaTimes />
// //                                                                             </Button>
// //                                                                         </div>
// //                                                                     </div>
// //                                                                 ))}
// //                                                                 {payrollData.bonuses.length === 0 && (
// //                                                                     <div className="text-muted ps-3 small">No bonuses added</div>
// //                                                                 )}
// //                                                             </div>

// //                                                             <div className="d-flex justify-content-between mt-3 pt-2 border-top">
// //                                                                 <strong>Total Earnings:</strong>
// //                                                                 <strong className="text-success">{payrollData.grossSalary.toFixed(2)}</strong>
// //                                                             </div>
// //                                                         </Card.Body>
// //                                                     </Card>
// //                                                 </Col>

// //                                                 <Col md={6}>
// //                                                     <Card className="bg-light">
// //                                                         <Card.Header>
// //                                                             <h5 className="card-title mb-0">Deductions</h5>
// //                                                         </Card.Header>
// //                                                         <Card.Body>
// //                                                             <div className="mb-3">
// //                                                                 <div className="d-flex justify-content-between align-items-center mb-2">
// //                                                                     <h6 className="mb-0">Standard Deductions</h6>
// //                                                                 </div>
// //                                                                 {payrollData.deductions.map((deduction, index) => (
// //                                                                     <div key={index} className="d-flex justify-content-between align-items-center ps-3 small">
// //                                                                         <span>{deduction.name}</span>
// //                                                                         <div>
// //                                                                             <span className="text-danger me-2">-{deduction.amount.toFixed(2)}</span>
// //                                                                             <Button
// //                                                                                 variant="link"
// //                                                                                 size="sm"
// //                                                                                 className="text-danger p-0"
// //                                                                                 onClick={() => removeItem(deduction.id, 'deductions')}
// //                                                                             >
// //                                                                                 <FaTimes />
// //                                                                             </Button>
// //                                                                         </div>
// //                                                                     </div>
// //                                                                 ))}
// //                                                                 {payrollData.deductions.length === 0 && (
// //                                                                     <div className="text-muted ps-3 small">No deductions added</div>
// //                                                                 )}
// //                                                             </div>

// //                                                             <div className="mb-3">
// //                                                                 <div className="d-flex justify-content-between align-items-center mb-2">
// //                                                                     <h6 className="mb-0">Loan Deductions</h6>
// //                                                                     <Button
// //                                                                         variant="outline-primary"
// //                                                                         size="sm"
// //                                                                         onClick={() => setShowLoanModal(true)}
// //                                                                     >
// //                                                                         <FaPlus className="me-1" /> Add
// //                                                                     </Button>
// //                                                                 </div>
// //                                                                 {payrollData.loans.map((loan, index) => (
// //                                                                     <div key={index} className="d-flex justify-content-between align-items-center ps-3 small">
// //                                                                         <span>{loan.title}</span>
// //                                                                         <div>
// //                                                                             <span className="text-danger me-2">-{loan.amount.toFixed(2)}</span>
// //                                                                             <Button
// //                                                                                 variant="link"
// //                                                                                 size="sm"
// //                                                                                 className="text-danger p-0"
// //                                                                                 onClick={() => removeItem(loan.id, 'loans')}
// //                                                                             >
// //                                                                                 <FaTimes />
// //                                                                             </Button>
// //                                                                         </div>
// //                                                                     </div>
// //                                                                 ))}
// //                                                                 {payrollData.loans.length === 0 && (
// //                                                                     <div className="text-muted ps-3 small">No loan deductions added</div>
// //                                                                 )}
// //                                                             </div>

// //                                                             <div className="d-flex justify-content-between mt-3 pt-2 border-top">
// //                                                                 <strong>Total Deductions:</strong>
// //                                                                 <strong className="text-danger">-{payrollData.totalDeductions.toFixed(2)}</strong>
// //                                                             </div>
// //                                                         </Card.Body>
// //                                                     </Card>
// //                                                 </Col>
// //                                             </Row>

// //                                             {/* <Row className="mt-4">
// //                                                 <Col md={8} className="mx-auto">
// //                                                     <Card className="bg-primary text-white">
// //                                                         <Card.Body className="text-center">
// //                                                             <h5 className="card-title">Net Salary</h5>
// //                                                             <h2>{payrollData.netSalary.toFixed(2)}</h2>
// //                                                             <div className="d-flex justify-content-between mt-3">
// //                                                                 <span>Gross Salary: {payrollData.grossSalary.toFixed(2)}</span>
// //                                                                 <span>Deductions: {payrollData.totalDeductions.toFixed(2)}</span>
// //                                                             </div>
// //                                                         </Card.Body>
// //                                                     </Card>
// //                                                 </Col>
// //                                             </Row>

// //                                             <div className="text-center mt-4">
// //                                                 <Button variant="primary" size="lg" onClick={handleSubmitPayroll}>
// //                                                     Save Payroll
// //                                                 </Button>
// //                                             </div> */}
// //                                         </>
// //                                     )}
// //                                 </Card.Body>
// //                             </Card>
// //                         </Col>
// //                     </Row>

// //                     {/* Modals */}
// //                     <DeductionModal />
// //                     <BonusModal />
// //                     <OvertimeModal />
// //                     <LoanModal />
// //                 </div>
// //             </div>
// //         </div>
// //     );
// // };

// // import React, { useState, useEffect } from 'react';
// // import axios from 'axios';
// // import Swal from 'sweetalert2';
// // import { FaPlus, FaTimes, FaEdit, FaCheck, FaFileExport, FaEye } from 'react-icons/fa';
// // import { Modal, Button, Form, Row, Col, Card, Badge, Table } from 'react-bootstrap';

// const PayrollCycleList = () => {
//     const [employees, setEmployees] = useState([]);
//     const [payrollCycles, setPayrollCycles] = useState([]);
//     const [currentCycle, setCurrentCycle] = useState(null);
//     const [selectedEmployee, setSelectedEmployee] = useState(null);
//     const [month, setMonth] = useState(new Date().getMonth() + 1);
//     const [year, setYear] = useState(new Date().getFullYear());
//     const [payrollData, setPayrollData] = useState({
//         basicSalary: 0,
//         allowances: [],
//         deductions: [],
//         loans: [],
//         overtime: [],
//         bonuses: [],
//         grossSalary: 0,
//         totalDeductions: 0,
//         netSalary: 0
//     });
//     const [showDeductionModal, setShowDeductionModal] = useState(false);
//     const [showBonusModal, setShowBonusModal] = useState(false);
//     const [showOvertimeModal, setShowOvertimeModal] = useState(false);
//     const [showLoanModal, setShowLoanModal] = useState(false);
//     const [showCreateCycleModal, setShowCreateCycleModal] = useState(false);
//     const [showPayslipModal, setShowPayslipModal] = useState(false);
//     const [newDeduction, setNewDeduction] = useState({ name: '', amount: 0 });
//     const [newBonus, setNewBonus] = useState({ name: '', amount: 0 });
//     const [newOvertime, setNewOvertime] = useState({ hours: 0, rate: 0, amount: 0 });
//     const [newLoan, setNewLoan] = useState({ title: '', amount: 0, installment: 0 });
//     const [newCycle, setNewCycle] = useState({ name: '', month: '', year: '' });

//     const token = JSON.parse(localStorage.getItem("user-info"))?.token;
//     const origin = localStorage.getItem("user-origin");

//     const months = [
//         { value: 1, label: "January" },
//         { value: 2, label: "February" },
//         { value: 3, label: "March" },
//         { value: 4, label: "April" },
//         { value: 5, label: "May" },
//         { value: 6, label: "June" },
//         { value: 7, label: "July" },
//         { value: 8, label: "August" },
//         { value: 9, label: "September" },
//         { value: 10, label: "October" },
//         { value: 11, label: "November" },
//         { value: 12, label: "December" }
//     ];

//     const years = Array.from({ length: 10 }, (_, i) => new Date().getFullYear() - 5 + i);

//     // Fetch employees and payroll cycles
//     useEffect(() => {
//         fetchEmployees();
//         fetchPayrollCycles();
//     }, []);

//     const fetchEmployees = async () => {
//         try {
//             const res = await axios.get(
//                 `${process.env.REACT_APP_BACKEND_URL}/api/employee`,
//                 { headers: { Authorization: `Bearer ${token}`, "Tenant-Origin": origin } }
//             );
//             setEmployees(res.data.data || []);
//         } catch (err) {
//             console.error("Error fetching employees:", err);
//             Swal.fire("Error!", "Failed to load employees", "error");
//         }
//     };

//     const fetchPayrollCycles = async () => {
//         try {
//             const res = await axios.get(
//                 `${process.env.REACT_APP_BACKEND_URL}/api/payroll-cycles`,
//                 { headers: { Authorization: `Bearer ${token}`, "Tenant-Origin": origin } }
//             );
//             setPayrollCycles(res.data || []);
//         } catch (err) {
//             console.error("Error fetching payroll cycles:", err);
//         }
//     };

//     // Create a new payroll cycle
//     const handleCreateCycle = async () => {
//         try {
//             const res = await axios.post(
//                 `${process.env.REACT_APP_BACKEND_URL}/api/payroll-cycles`,
//                 { 
//                     name: newCycle.name,
//                     // period: `${year}-${month.toString().padStart(2, '0')}`,
//                     month:newCycle.month,
//                     year:newCycle.year,
//                     status: 'open'
//                 },
//                 { headers: { Authorization: `Bearer ${token}`, "Tenant-Origin": origin } }
//             );

//             setPayrollCycles([...payrollCycles, res.data.data]);
//             setShowCreateCycleModal(false);
//             setNewCycle({ name: '', month: '',year:'' });
//             Swal.fire("Success!", "Payroll cycle created successfully", "success");
//         } catch (error) {
//             console.error("Error creating payroll cycle:", error);
//             Swal.fire("Error!", "Failed to create payroll cycle", "error");
//         }
//     };

//     // Process payroll for all employees in a cycle
//     const handleProcessPayroll = async (cycleId) => {
//         try {
//             const res = await axios.post(
//                 `${process.env.REACT_APP_BACKEND_URL}/api/payroll-cycles/${cycleId}/process`,
//                 {},
//                 { headers: { Authorization: `Bearer ${token}`, "Tenant-Origin": origin } }
//             );

//             // Update the cycle status
//             const updatedCycles = payrollCycles.map(cycle => 
//                 cycle.id === cycleId ? { ...cycle, status: 'processed' } : cycle
//             );
//             setPayrollCycles(updatedCycles);
//             Swal.fire("Success!", "Payroll processed successfully", "success");
//         } catch (error) {
//             console.error("Error processing payroll:", error);
//             Swal.fire("Error!", "Failed to process payroll", "error");
//         }
//     };

//     // Approve a payroll cycle
//     const handleApproveCycle = async (cycleId) => {
//         try {
//             const res = await axios.post(
//                 `${process.env.REACT_APP_BACKEND_URL}/api/payroll-cycles/${cycleId}/approve`,
//                 {},
//                 { headers: { Authorization: `Bearer ${token}`, "Tenant-Origin": origin } }
//             );

//             // Update the cycle status
//             const updatedCycles = payrollCycles.map(cycle => 
//                 cycle.id === cycleId ? { ...cycle, status: 'approved' } : cycle
//             );
//             setPayrollCycles(updatedCycles);
//             Swal.fire("Success!", "Payroll cycle approved successfully", "success");
//         } catch (error) {
//             console.error("Error approving payroll cycle:", error);
//             Swal.fire("Error!", "Failed to approve payroll cycle", "error");
//         }
//     };

//     // Fetch employee details when selected
//     useEffect(() => {
//         if (selectedEmployee && currentCycle) {
//             fetchEmployeePayrollData(selectedEmployee, currentCycle.id);
//         }
//     }, [selectedEmployee, currentCycle]);

//     const fetchEmployeePayrollData = async (employeeId, cycleId) => {
//         try {
//             const response = await axios.get(
//                 `${process.env.REACT_APP_BACKEND_URL}/api/payroll-cycles/${cycleId}/employees/${employeeId}`,
//                 { headers: { Authorization: `Bearer ${token}`, "Tenant-Origin": origin } }
//             );

//             const payrollData = response.data?.data;
//             if (payrollData) {
//                 setPayrollData(payrollData);
//             }
//         } catch (error) {
//             console.error("Error fetching employee payroll data:", error);
//             // If no payroll data exists, fetch employee details to calculate
//             if (error.response?.status === 404) {
//                 calculateEmployeePayroll(employeeId);
//             } else {
//                 Swal.fire("Error!", "Failed to load employee payroll data", "error");
//             }
//         }
//     };

//     const calculateEmployeePayroll = async (employeeId) => {
//         try {
//             const response = await axios.get(
//                 `${process.env.REACT_APP_BACKEND_URL}/api/employee/${employeeId}`,
//                 { headers: { Authorization: `Bearer ${token}`, "Tenant-Origin": origin } }
//             );

//             const employeeData = response.data?.data;
//             if (employeeData) {
//                 // Calculate basic salary
//                 const basicSalary = parseFloat(employeeData.contract?.salary || 0);

//                 // Get allowances from contract
//                 const allowances = employeeData.contract?.allowances?.map(a => ({
//                     id: a.id,
//                     name: a.name,
//                     amount: parseFloat(a.pivot.amount || 0)
//                 })) || [];

//                 // Get deductions from contract
//                 const deductions = employeeData.contract?.deductions?.map(d => ({
//                     id: d.id,
//                     name: d.name,
//                     amount: parseFloat(d.pivot.amount || 0)
//                 })) || [];

//                 // Get active loans
//                 const loans = employeeData.loans?.filter(l => l.status === 'approved').map(l => ({
//                     id: l.id,
//                     title: l.title,
//                     amount: parseFloat(l.installment_amount || 0)
//                 })) || [];

//                 // Get overtime for selected month/year
//                 const overtime = employeeData.overtime?.filter(ot => {
//                     const otDate = new Date(ot.date);
//                     return otDate.getMonth() + 1 === month && otDate.getFullYear() === year;
//                 }).map(ot => ({
//                     id: ot.id,
//                     type: ot.overtime_type?.name,
//                     hours: ot.hours,
//                     rate: ot.rate,
//                     amount: parseFloat(ot.amount || 0)
//                 })) || [];

//                 // Calculate totals
//                 const totalAllowances = allowances.reduce((sum, a) => sum + a.amount, 0);
//                 const totalDeductions = deductions.reduce((sum, d) => sum + d.amount, 0);
//                 const totalLoans = loans.reduce((sum, l) => sum + l.amount, 0);
//                 const totalOvertime = overtime.reduce((sum, ot) => sum + ot.amount, 0);

//                 const grossSalary = basicSalary + totalAllowances + totalOvertime;
//                 const totalDeductionsAll = totalDeductions + totalLoans;
//                 const netSalary = grossSalary - totalDeductionsAll;

//                 setPayrollData({
//                     basicSalary,
//                     allowances,
//                     deductions,
//                     loans,
//                     overtime,
//                     bonuses: [],
//                     grossSalary,
//                     totalDeductions: totalDeductionsAll,
//                     netSalary
//                 });
//             }
//         } catch (error) {
//             console.error("Error calculating employee payroll:", error);
//             Swal.fire("Error!", "Failed to calculate employee payroll", "error");
//         }
//     };

//     // Handler for adding a new deduction
//     const handleAddDeduction = () => {
//         if (!newDeduction.name || newDeduction.amount <= 0) {
//             Swal.fire("Error!", "Please enter a valid name and amount", "error");
//             return;
//         }

//         const updatedDeductions = [...payrollData.deductions, {
//             id: Date.now(), // temporary ID
//             name: newDeduction.name,
//             amount: parseFloat(newDeduction.amount)
//         }];

//         updatePayrollData(updatedDeductions, 'deductions');
//         setNewDeduction({ name: '', amount: 0 });
//         setShowDeductionModal(false);
//     };

//     // Handler for adding a new bonus
//     const handleAddBonus = () => {
//         if (!newBonus.name || newBonus.amount <= 0) {
//             Swal.fire("Error!", "Please enter a valid name and amount", "error");
//             return;
//         }

//         const updatedBonuses = [...payrollData.bonuses, {
//             id: Date.now(), // temporary ID
//             name: newBonus.name,
//             amount: parseFloat(newBonus.amount)
//         }];

//         updatePayrollData(updatedBonuses, 'bonuses');
//         setNewBonus({ name: '', amount: 0 });
//         setShowBonusModal(false);
//     };

//     // Handler for adding overtime
//     const handleAddOvertime = () => {
//         if (newOvertime.hours <= 0 || newOvertime.rate <= 0) {
//             Swal.fire("Error!", "Please enter valid hours and rate", "error");
//             return;
//         }

//         const amount = newOvertime.hours * newOvertime.rate;
//         const updatedOvertime = [...payrollData.overtime, {
//             id: Date.now(), // temporary ID
//             type: "Manual Entry",
//             hours: newOvertime.hours,
//             rate: newOvertime.rate,
//             amount: amount
//         }];

//         updatePayrollData(updatedOvertime, 'overtime');
//         setNewOvertime({ hours: 0, rate: 0, amount: 0 });
//         setShowOvertimeModal(false);
//     };

//     // Handler for adding a loan deduction
//     const handleAddLoan = () => {
//         if (!newLoan.title || newLoan.amount <= 0) {
//             Swal.fire("Error!", "Please enter a valid title and amount", "error");
//             return;
//         }

//         const updatedLoans = [...payrollData.loans, {
//             id: Date.now(), // temporary ID
//             title: newLoan.title,
//             amount: parseFloat(newLoan.amount)
//         }];

//         updatePayrollData(updatedLoans, 'loans');
//         setNewLoan({ title: '', amount: 0, installment: 0 });
//         setShowLoanModal(false);
//     };

//     // Update payroll data when any component changes
//     const updatePayrollData = (updatedItems, field) => {
//         const updatedData = { ...payrollData, [field]: updatedItems };

//         // Recalculate totals
//         const totalAllowances = updatedData.allowances.reduce((sum, a) => sum + a.amount, 0);
//         const totalDeductions = updatedData.deductions.reduce((sum, d) => sum + d.amount, 0);
//         const totalLoans = updatedData.loans.reduce((sum, l) => sum + l.amount, 0);
//         const totalOvertime = updatedData.overtime.reduce((sum, ot) => sum + ot.amount, 0);
//         const totalBonuses = updatedData.bonuses.reduce((sum, b) => sum + b.amount, 0);

//         updatedData.grossSalary = updatedData.basicSalary + totalAllowances + totalOvertime + totalBonuses;
//         updatedData.totalDeductions = totalDeductions + totalLoans;
//         updatedData.netSalary = updatedData.grossSalary - updatedData.totalDeductions;

//         setPayrollData(updatedData);
//     };

//     // Remove an item from payroll components
//     const removeItem = (id, field) => {
//         const updatedItems = payrollData[field].filter(item => item.id !== id);
//         updatePayrollData(updatedItems, field);
//     };

//     // Save individual employee payroll data
//     const handleSaveEmployeePayroll = async () => {
//         if (!selectedEmployee || !currentCycle) {
//             Swal.fire("Error!", "Please select an employee and payroll cycle", "error");
//             return;
//         }

//         try {
//             const payload = {
//                 employee_id: selectedEmployee,
//                 payroll_cycle_id: currentCycle.id,
//                 basic_salary: payrollData.basicSalary,
//                 allowances: payrollData.allowances,
//                 deductions: payrollData.deductions,
//                 loans: payrollData.loans,
//                 overtime: payrollData.overtime,
//                 bonuses: payrollData.bonuses,
//                 gross_salary: payrollData.grossSalary,
//                 total_deductions: payrollData.totalDeductions,
//                 net_salary: payrollData.netSalary
//             };

//             const res = await axios.post(
//                 `${process.env.REACT_APP_BACKEND_URL}/api/payroll`,
//                 payload,
//                 { headers: { Authorization: `Bearer ${token}`, "Tenant-Origin": origin } }
//             );

//             Swal.fire("Success!", "Payroll data saved successfully", "success");
//         } catch (error) {
//             console.error("Error saving payroll:", error);
//             Swal.fire("Error!", "Failed to save payroll data", "error");
//         }
//     };

//     // Generate WPS file for approved payroll cycle
//     const handleGenerateWPS = async (cycleId) => {
//         try {
//             const res = await axios.get(
//                 `${process.env.REACT_APP_BACKEND_URL}/api/payroll-cycles/${cycleId}/wps`,
//                 { 
//                     headers: { Authorization: `Bearer ${token}`, "Tenant-Origin": origin },
//                     responseType: 'blob'
//                 }
//             );

//             // Create a blob from the PDF stream
//             const blob = new Blob([res.data], { type: 'application/pdf' });
//             const url = window.URL.createObjectURL(blob);

//             // Create a temporary link and trigger download
//             const link = document.createElement('a');
//             link.href = url;
//             link.setAttribute('download', `wps-payroll-${cycleId}.pdf`);
//             document.body.appendChild(link);
//             link.click();
//             link.remove();

//             Swal.fire("Success!", "WPS file generated successfully", "success");
//         } catch (error) {
//             console.error("Error generating WPS file:", error);
//             Swal.fire("Error!", "Failed to generate WPS file", "error");
//         }
//     };

//     // Modal components
//     const CreateCycleModal = () => (
//         <Modal show={showCreateCycleModal} onHide={() => setShowCreateCycleModal(false)}>
//             <Modal.Header closeButton>
//                 <Modal.Title>Create Payroll Cycle</Modal.Title>
//             </Modal.Header>
//             <Modal.Body>
//                 <Form.Group className="mb-3">
//                     <Form.Label>Cycle Name</Form.Label>
//                     <Form.Control
//                         type="text"
//                         value={newCycle.name}
//                         onChange={(e) => setNewCycle({ ...newCycle, name: e.target.value })}
//                         placeholder="Enter cycle name (e.g., January 2023 Payroll)"
//                     />
//                 </Form.Group>
//                 <Form.Group className="mb-3">
//                     <Form.Label>Period</Form.Label>
//                     <div className="d-flex gap-2">
//                         <Form.Select
//                             value={newCycle.month}
//                             onChange={(e) => setNewCycle({ ...newCycle, month: parseInt(e.target.value) })}
//                             name='month'
//                         >
//                             {months.map(m => (
//                                 <option key={m.value} value={m.value}>
//                                     {m.label}
//                                 </option>
//                             ))}
//                         </Form.Select>
//                         <Form.Select
//                             value={newCycle.year}
//                             onChange={(e) => setNewCycle({ ...newCycle, year: parseInt(e.target.value) })}
//                             name="year"
//                         >
//                             {years.map(y => (
//                                 <option key={y} value={y}>
//                                     {y}
//                                 </option>
//                             ))}
//                         </Form.Select>
//                     </div>
//                 </Form.Group>
//             </Modal.Body>
//             <Modal.Footer>
//                 <Button variant="secondary" onClick={() => setShowCreateCycleModal(false)}>
//                     Cancel
//                 </Button>
//                 <Button variant="primary" onClick={handleCreateCycle}>
//                     Create Cycle
//                 </Button>
//             </Modal.Footer>
//         </Modal>
//     );

//     const DeductionModal = () => (
//         <Modal show={showDeductionModal} onHide={() => setShowDeductionModal(false)}>
//             <Modal.Header closeButton>
//                 <Modal.Title>Add Deduction</Modal.Title>
//             </Modal.Header>
//             <Modal.Body>
//                 <Form.Group className="mb-3">
//                     <Form.Label>Deduction Name</Form.Label>
//                     <Form.Control
//                         type="text"
//                         value={newDeduction.name}
//                         onChange={(e) => setNewDeduction({ ...newDeduction, name: e.target.value })}
//                         placeholder="Enter deduction name"
//                     />
//                 </Form.Group>
//                 <Form.Group className="mb-3">
//                     <Form.Label>Amount</Form.Label>
//                     <Form.Control
//                         type="number"
//                         value={newDeduction.amount}
//                         onChange={(e) => setNewDeduction({ ...newDeduction, amount: parseFloat(e.target.value) || 0 })}
//                         placeholder="Enter amount"
//                     />
//                 </Form.Group>
//             </Modal.Body>
//             <Modal.Footer>
//                 <Button variant="secondary" onClick={() => setShowDeductionModal(false)}>
//                     Cancel
//                 </Button>
//                 <Button variant="primary" onClick={handleAddDeduction}>
//                     Add Deduction
//                 </Button>
//             </Modal.Footer>
//         </Modal>
//     );

//     const BonusModal = () => (
//         <Modal show={showBonusModal} onHide={() => setShowBonusModal(false)}>
//             <Modal.Header closeButton>
//                 <Modal.Title>Add Bonus</Modal.Title>
//             </Modal.Header>
//             <Modal.Body>
//                 <Form.Group className="mb-3">
//                     <Form.Label>Bonus Name</Form.Label>
//                     <Form.Control
//                         type="text"
//                         value={newBonus.name}
//                         onChange={(e) => setNewBonus({ ...newBonus, name: e.target.value })}
//                         placeholder="Enter bonus name"
//                     />
//                 </Form.Group>
//                 <Form.Group className="mb-3">
//                     <Form.Label>Amount</Form.Label>
//                     <Form.Control
//                         type="number"
//                         value={newBonus.amount}
//                         onChange={(e) => setNewBonus({ ...newBonus, amount: parseFloat(e.target.value) || 0 })}
//                         placeholder="Enter amount"
//                     />
//                 </Form.Group>
//             </Modal.Body>
//             <Modal.Footer>
//                 <Button variant="secondary" onClick={() => setShowBonusModal(false)}>
//                     Cancel
//                 </Button>
//                 <Button variant="primary" onClick={handleAddBonus}>
//                     Add Bonus
//                 </Button>
//             </Modal.Footer>
//         </Modal>
//     );

//     const OvertimeModal = () => (
//         <Modal show={showOvertimeModal} onHide={() => setShowOvertimeModal(false)}>
//             <Modal.Header closeButton>
//                 <Modal.Title>Add Overtime</Modal.Title>
//             </Modal.Header>
//             <Modal.Body>
//                 <Form.Group className="mb-3">
//                     <Form.Label>Hours</Form.Label>
//                     <Form.Control
//                         type="number"
//                         step="0.5"
//                         value={newOvertime.hours}
//                         onChange={(e) => setNewOvertime({ ...newOvertime, hours: parseFloat(e.target.value) || 0 })}
//                         placeholder="Enter hours"
//                     />
//                 </Form.Group>
//                 <Form.Group className="mb-3">
//                     <Form.Label>Rate per Hour</Form.Label>
//                     <Form.Control
//                         type="number"
//                         value={newOvertime.rate}
//                         onChange={(e) => setNewOvertime({ ...newOvertime, rate: parseFloat(e.target.value) || 0 })}
//                         placeholder="Enter rate"
//                     />
//                 </Form.Group>
//                 <Form.Group className="mb-3">
//                     <Form.Label>Total Amount: {newOvertime.hours * newOvertime.rate}</Form.Label>
//                 </Form.Group>
//             </Modal.Body>
//             <Modal.Footer>
//                 <Button variant="secondary" onClick={() => setShowOvertimeModal(false)}>
//                     Cancel
//                 </Button>
//                 <Button variant="primary" onClick={handleAddOvertime}>
//                     Add Overtime
//                 </Button>
//             </Modal.Footer>
//         </Modal>
//     );

//     const LoanModal = () => (
//         <Modal show={showLoanModal} onHide={() => setShowLoanModal(false)}>
//             <Modal.Header closeButton>
//                 <Modal.Title>Add Loan Deduction</Modal.Title>
//             </Modal.Header>
//             <Modal.Body>
//                 <Form.Group className="mb-3">
//                     <Form.Label>Loan Title</Form.Label>
//                     <Form.Control
//                         type="text"
//                         value={newLoan.title}
//                         onChange={(e) => setNewLoan({ ...newLoan, title: e.target.value })}
//                         placeholder="Enter loan title"
//                     />
//                 </Form.Group>
//                 <Form.Group className="mb-3">
//                     <Form.Label>Deduction Amount</Form.Label>
//                     <Form.Control
//                         type="number"
//                         value={newLoan.amount}
//                         onChange={(e) => setNewLoan({ ...newLoan, amount: parseFloat(e.target.value) || 0 })}
//                         placeholder="Enter amount"
//                     />
//                 </Form.Group>
//             </Modal.Body>
//             <Modal.Footer>
//                 <Button variant="secondary" onClick={() => setShowLoanModal(false)}>
//                     Cancel
//                 </Button>
//                 <Button variant="primary" onClick={handleAddLoan}>
//                     Add Loan Deduction
//                 </Button>
//             </Modal.Footer>
//         </Modal>
//     );

//     const PayslipModal = ({ employee, data }) => (
//         <Modal show={showPayslipModal} onHide={() => setShowPayslipModal(false)} size="lg">
//             <Modal.Header closeButton>
//                 <Modal.Title>Payslip Preview</Modal.Title>
//             </Modal.Header>
//             <Modal.Body>
//                 <Card>
//                     <Card.Body>
//                         <div className="text-center mb-4">
//                             <h4>PAYSLIP</h4>
//                             <p className="mb-0">{months.find(m => m.value === month)?.label} {year}</p>
//                         </div>

//                         <Row className="mb-4">
//                             <Col md={6}>
//                                 <h6>Employee Details</h6>
//                                 <p className="mb-0">
//                                     {employee?.first_name} {employee?.last_name}
//                                 </p>
//                                 <p className="mb-0">ID: {employee?.employee_code}</p>
//                             </Col>
//                             <Col md={6} className="text-md-end">
//                                 <h6>Payroll Details</h6>
//                                 <p className="mb-0">Cycle: {currentCycle?.name}</p>
//                                 <p className="mb-0">Payment Date: {new Date().toLocaleDateString()}</p>
//                             </Col>
//                         </Row>

//                         <Row>
//                             <Col md={6}>
//                                 <h6>Earnings</h6>
//                                 <Table size="sm" borderless>
//                                     <tbody>
//                                         <tr>
//                                             <td>Basic Salary</td>
//                                             <td className="text-end">AED {data.basicSalary.toFixed(2)}</td>
//                                         </tr>
//                                         {data.allowances.map((a, i) => (
//                                             <tr key={i}>
//                                                 <td>{a.name}</td>
//                                                 <td className="text-end">AED {a.amount.toFixed(2)}</td>
//                                             </tr>
//                                         ))}
//                                         {data.overtime.map((ot, i) => (
//                                             <tr key={i}>
//                                                 <td>Overtime ({ot.hours} hrs)</td>
//                                                 <td className="text-end">AED {ot.amount.toFixed(2)}</td>
//                                             </tr>
//                                         ))}
//                                         {data.bonuses.map((b, i) => (
//                                             <tr key={i}>
//                                                 <td>{b.name}</td>
//                                                 <td className="text-end">AED {b.amount.toFixed(2)}</td>
//                                             </tr>
//                                         ))}
//                                         <tr className="fw-bold">
//                                             <td>Total Earnings</td>
//                                             <td className="text-end">AED {data.grossSalary.toFixed(2)}</td>
//                                         </tr>
//                                     </tbody>
//                                 </Table>
//                             </Col>
//                             <Col md={6}>
//                                 <h6>Deductions</h6>
//                                 <Table size="sm" borderless>
//                                     <tbody>
//                                         {data.deductions.map((d, i) => (
//                                             <tr key={i}>
//                                                 <td>{d.name}</td>
//                                                 <td className="text-end">AED {d.amount.toFixed(2)}</td>
//                                             </tr>
//                                         ))}
//                                         {data.loans.map((l, i) => (
//                                             <tr key={i}>
//                                                 <td>{l.title}</td>
//                                                 <td className="text-end">AED {l.amount.toFixed(2)}</td>
//                                             </tr>
//                                         ))}
//                                         <tr className="fw-bold">
//                                             <td>Total Deductions</td>
//                                             <td className="text-end">AED {data.totalDeductions.toFixed(2)}</td>
//                                         </tr>
//                                     </tbody>
//                                 </Table>
//                             </Col>
//                         </Row>

//                         <hr />

//                         <Row>
//                             <Col md={12}>
//                                 <div className="d-flex justify-content-between fw-bold fs-5">
//                                     <span>Net Salary</span>
//                                     <span>AED {data.netSalary.toFixed(2)}</span>
//                                 </div>
//                             </Col>
//                         </Row>
//                     </Card.Body>
//                 </Card>
//             </Modal.Body>
//             <Modal.Footer>
//                 <Button variant="secondary" onClick={() => setShowPayslipModal(false)}>
//                     Close
//                 </Button>
//                 <Button variant="primary" onClick={() => window.print()}>
//                     Print Payslip
//                 </Button>
//             </Modal.Footer>
//         </Modal>
//     );

//     const getStatusBadge = (status) => {
//         switch (status) {
//             case 'draft':
//                 return <Badge bg="secondary">Draft</Badge>;
//             case 'processed':
//                 return <Badge bg="warning">Processed</Badge>;
//             case 'approved':
//                 return <Badge bg="success">Approved</Badge>;
//             default:
//                 return <Badge bg="secondary">{status}</Badge>;
//         }
//     };

//     return (
//         <div className="main-content">
//             <div className="page-content">
//                 <div className="container-fluid">
//                     <div className="row">
//                         <div className="col-12">
//                             <div className="page-title-box d-sm-flex align-items-center justify-content-between">
//                                 <h4 className="mb-sm-0 font-size-18">Payroll Management</h4>
//                                 <div className="page-title-right">
//                                     <ol className="breadcrumb m-0">
//                                         <li className="breadcrumb-item"><a href="#">Payroll</a></li>
//                                         <li className="breadcrumb-item active">Payroll Cycles</li>
//                                     </ol>
//                                 </div>
//                             </div>
//                         </div>
//                     </div>

//                     <Row>
//                         <Col lg={12}>
//                             <Card>
//                                 <Card.Body>
//                                     <div className="d-flex justify-content-between align-items-center mb-4">
//                                         <h4 className="card-title mb-0">Payroll Cycles</h4>
//                                         <Button variant="primary" onClick={() => setShowCreateCycleModal(true)}>
//                                             <FaPlus className="me-1" /> Create New Cycle
//                                         </Button>
//                                     </div>

//                                     <Table responsive>
//                                         <thead>
//                                             <tr>
//                                                 <th>Cycle Name</th>
//                                                 <th>Period</th>
//                                                 <th>Status</th>
//                                                 <th>Employees</th>
//                                                 <th>Total Amount</th>
//                                                 <th>Actions</th>
//                                             </tr>
//                                         </thead>
//                                         <tbody>
//                                             {payrollCycles.map(cycle => (
//                                                 <tr key={cycle.id}>
//                                                     <td>{cycle.name}</td>
//                                                     <td>{cycle.period}</td>
//                                                     <td>{getStatusBadge(cycle.status)}</td>
//                                                     <td>{cycle.employee_count || 0}</td>
//                                                     <td>AED {cycle.total_amount ? cycle.total_amount.toFixed(2) : '0.00'}</td>
//                                                     <td>
//                                                         <div className="d-flex gap-2">
//                                                             {cycle.status === 'draft' && (
//                                                                 <Button 
//                                                                     variant="outline-primary" 
//                                                                     size="sm"
//                                                                     onClick={() => {
//                                                                         setCurrentCycle(cycle);
//                                                                         setMonth(parseInt(cycle.period.split('-')[1]));
//                                                                         setYear(parseInt(cycle.period.split('-')[0]));
//                                                                     }}
//                                                                 >
//                                                                     <FaEdit /> Edit
//                                                                 </Button>
//                                                             )}
//                                                             {cycle.status === 'draft' && (
//                                                                 <Button 
//                                                                     variant="success" 
//                                                                     size="sm"
//                                                                     onClick={() => handleProcessPayroll(cycle.id)}
//                                                                 >
//                                                                     <FaCheck /> Process
//                                                                 </Button>
//                                                             )}
//                                                             {cycle.status === 'processed' && (
//                                                                 <Button 
//                                                                     variant="primary" 
//                                                                     size="sm"
//                                                                     onClick={() => handleApproveCycle(cycle.id)}
//                                                                 >
//                                                                     <FaCheck /> Approve
//                                                                 </Button>
//                                                             )}
//                                                             {cycle.status === 'approved' && (
//                                                                 <Button 
//                                                                     variant="info" 
//                                                                     size="sm"
//                                                                     onClick={() => handleGenerateWPS(cycle.id)}
//                                                                 >
//                                                                     <FaFileExport /> WPS
//                                                                 </Button>
//                                                             )}
//                                                         </div>
//                                                     </td>
//                                                 </tr>
//                                             ))}
//                                             {payrollCycles.length === 0 && (
//                                                 <tr>
//                                                     <td colSpan="6" className="text-center py-4">
//                                                         No payroll cycles found. Create your first cycle to get started.
//                                                     </td>
//                                                 </tr>
//                                             )}
//                                         </tbody>
//                                     </Table>
//                                 </Card.Body>
//                             </Card>
//                         </Col>
//                     </Row>

//                     {currentCycle && (
//                         <Row className="mt-4">
//                             <Col lg={12}>
//                                 <Card>
//                                     <Card.Body>
//                                         <div className="d-flex justify-content-between align-items-center mb-4">
//                                             <h4 className="card-title mb-0">Edit Payroll: {currentCycle.name}</h4>
//                                             <div>
//                                                 <span className="me-2">{getStatusBadge(currentCycle.status)}</span>
//                                                 {currentCycle.status === 'processed' && (
//                                                     <Button 
//                                                         variant="primary" 
//                                                         onClick={() => handleApproveCycle(currentCycle.id)}
//                                                     >
//                                                         <FaCheck /> Approve Cycle
//                                                     </Button>
//                                                 )}
//                                             </div>
//                                         </div>

//                                         <Row className="mb-3">
//                                             <Col md={4}>
//                                                 <Form.Group>
//                                                     <Form.Label>Select Employee</Form.Label>
//                                                     <Form.Select
//                                                         value={selectedEmployee || ''}
//                                                         onChange={(e) => setSelectedEmployee(e.target.value)}
//                                                     >
//                                                         <option value="">Select Employee</option>
//                                                         {employees.map(emp => (
//                                                             <option key={emp.id} value={emp.id}>
//                                                                 {emp.first_name} {emp.last_name} ({emp.employee_code})
//                                                             </option>
//                                                         ))}
//                                                     </Form.Select>
//                                                 </Form.Group>
//                                             </Col>
//                                             <Col md={4}>
//                                                 <Form.Group>
//                                                     <Form.Label>Month</Form.Label>
//                                                     <Form.Select
//                                                         value={month}
//                                                         onChange={(e) => setMonth(parseInt(e.target.value))}
//                                                         disabled={currentCycle.status !== 'draft'}
//                                                     >
//                                                         {months.map(m => (
//                                                             <option key={m.value} value={m.value}>
//                                                                 {m.label}
//                                                             </option>
//                                                         ))}
//                                                     </Form.Select>
//                                                 </Form.Group>
//                                             </Col>
//                                             <Col md={4}>
//                                                 <Form.Group>
//                                                     <Form.Label>Year</Form.Label>
//                                                     <Form.Select
//                                                         value={year}
//                                                         onChange={(e) => setYear(parseInt(e.target.value))}
//                                                         disabled={currentCycle.status !== 'draft'}
//                                                     >
//                                                         {years.map(y => (
//                                                             <option key={y} value={y}>
//                                                                 {y}
//                                                             </option>
//                                                         ))}
//                                                     </Form.Select>
//                                                 </Form.Group>
//                                             </Col>
//                                         </Row>

//                                         {selectedEmployee && (
//                                             <>
//                                                 <Row className="mb-4">
//                                                     <Col md={12}>
//                                                         <Card className="bg-gradient bg-white text-primary shadow-sm">
//                                                             <Card.Body className="d-flex flex-column flex-md-row align-items-center justify-content-between">
//                                                                 <div>
//                                                                     <h5 className="mb-2">Net Salary</h5>
//                                                                     <h2 className="mb-0 fw-bold">AED {payrollData.netSalary.toFixed(2)}</h2>
//                                                                     <div className="small mt-2">
//                                                                         Gross: AED {payrollData.grossSalary.toFixed(2)} &nbsp; | &nbsp;
//                                                                         Deductions: AED {payrollData.totalDeductions.toFixed(2)}
//                                                                     </div>
//                                                                 </div>
//                                                                 <div className="mt-3 mt-md-0 d-flex gap-2">
//                                                                     <Button
//                                                                         variant="outline-primary"
//                                                                         onClick={() => setShowPayslipModal(true)}
//                                                                     >
//                                                                         <FaEye className="me-1" /> Preview Payslip
//                                                                     </Button>
//                                                                     {currentCycle.status === 'draft' && (
//                                                                         <Button
//                                                                             variant="primary"
//                                                                             onClick={handleSaveEmployeePayroll}
//                                                                         >
//                                                                             💾 Save Changes
//                                                                         </Button>
//                                                                     )}
//                                                                 </div>
//                                                             </Card.Body>
//                                                         </Card>
//                                                     </Col>
//                                                 </Row>
//                                                 <Row>
//                                                     <Col md={6}>
//                                                         <Card className="bg-light">
//                                                             <Card.Header>
//                                                                 <h5 className="card-title mb-0">Earnings</h5>
//                                                             </Card.Header>
//                                                             <Card.Body>
//                                                                 <div className="d-flex justify-content-between mb-2">
//                                                                     <span>Basic Salary:</span>
//                                                                     <span className="fw-semibold">{payrollData.basicSalary.toFixed(2)}</span>
//                                                                 </div>

//                                                                 <div className="mb-3">
//                                                                     <div className="d-flex justify-content-between align-items-center mb-2">
//                                                                         <h6 className="mb-0">Allowances</h6>
//                                                                         {currentCycle.status === 'draft' && (
//                                                                             <Button
//                                                                                 variant="outline-primary"
//                                                                                 size="sm"
//                                                                                 onClick={() => setShowDeductionModal(true)}
//                                                                             >
//                                                                                 <FaPlus className="me-1" /> Add
//                                                                             </Button>
//                                                                         )}
//                                                                     </div>
//                                                                     {payrollData.allowances.map((allowance, index) => (
//                                                                         <div key={index} className="d-flex justify-content-between align-items-center ps-3 small">
//                                                                             <span>{allowance.name}</span>
//                                                                             <div>
//                                                                                 <span className="text-success me-2">+{allowance.amount.toFixed(2)}</span>
//                                                                                 {currentCycle.status === 'draft' && (
//                                                                                     <Button
//                                                                                         variant="link"
//                                                                                         size="sm"
//                                                                                         className="text-danger p-0"
//                                                                                         onClick={() => removeItem(allowance.id, 'allowances')}
//                                                                                     >
//                                                                                         <FaTimes />
//                                                                                     </Button>
//                                                                                 )}
//                                                                             </div>
//                                                                         </div>
//                                                                     ))}
//                                                                     {payrollData.allowances.length === 0 && (
//                                                                         <div className="text-muted ps-3 small">No allowances added</div>
//                                                                     )}
//                                                                 </div>

//                                                                 <div className="mb-3">
//                                                                     <div className="d-flex justify-content-between align-items-center mb-2">
//                                                                         <h6 className="mb-0">Overtime</h6>
//                                                                         {currentCycle.status === 'draft' && (
//                                                                             <Button
//                                                                                 variant="outline-primary"
//                                                                                 size="sm"
//                                                                                 onClick={() => setShowOvertimeModal(true)}
//                                                                             >
//                                                                                 <FaPlus className="me-1" /> Add
//                                                                             </Button>
//                                                                         )}
//                                                                     </div>
//                                                                     {payrollData.overtime.map((ot, index) => (
//                                                                         <div key={index} className="d-flex justify-content-between align-items-center ps-3 small">
//                                                                             <span>{ot.type} ({ot.hours} hrs)</span>
//                                                                             <div>
//                                                                                 <span className="text-success me-2">+{ot.amount.toFixed(2)}</span>
//                                                                                 {currentCycle.status === 'draft' && (
//                                                                                     <Button
//                                                                                         variant="link"
//                                                                                         size="sm"
//                                                                                         className="text-danger p-0"
//                                                                                         onClick={() => removeItem(ot.id, 'overtime')}
//                                                                                     >
//                                                                                         <FaTimes />
//                                                                                     </Button>
//                                                                                 )}
//                                                                             </div>
//                                                                         </div>
//                                                                     ))}
//                                                                     {payrollData.overtime.length === 0 && (
//                                                                         <div className="text-muted ps-3 small">No overtime added</div>
//                                                                     )}
//                                                                 </div>

//                                                                 <div className="mb-3">
//                                                                     <div className="d-flex justify-content-between align-items-center mb-2">
//                                                                         <h6 className="mb-0">Bonuses</h6>
//                                                                         {currentCycle.status === 'draft' && (
//                                                                             <Button
//                                                                                 variant="outline-primary"
//                                                                                 size="sm"
//                                                                                 onClick={() => setShowBonusModal(true)}
//                                                                             >
//                                                                                 <FaPlus className="me-1" /> Add
//                                                                             </Button>
//                                                                         )}
//                                                                     </div>
//                                                                     {payrollData.bonuses.map((bonus, index) => (
//                                                                         <div key={index} className="d-flex justify-content-between align-items-center ps-3 small">
//                                                                             <span>{bonus.name}</span>
//                                                                             <div>
//                                                                                 <span className="text-success me-2">+{bonus.amount.toFixed(2)}</span>
//                                                                                 {currentCycle.status === 'draft' && (
//                                                                                     <Button
//                                                                                         variant="link"
//                                                                                         size="sm"
//                                                                                         className="text-danger p-0"
//                                                                                         onClick={() => removeItem(bonus.id, 'bonuses')}
//                                                                                     >
//                                                                                         <FaTimes />
//                                                                                     </Button>
//                                                                                 )}
//                                                                             </div>
//                                                                         </div>
//                                                                     ))}
//                                                                     {payrollData.bonuses.length === 0 && (
//                                                                         <div className="text-muted ps-3 small">No bonuses added</div>
//                                                                     )}
//                                                                 </div>

//                                                                 <div className="d-flex justify-content-between mt-3 pt-2 border-top">
//                                                                     <strong>Total Earnings:</strong>
//                                                                     <strong className="text-success">{payrollData.grossSalary.toFixed(2)}</strong>
//                                                                 </div>
//                                                             </Card.Body>
//                                                         </Card>
//                                                     </Col>

//                                                     <Col md={6}>
//                                                         <Card className="bg-light">
//                                                             <Card.Header>
//                                                                 <h5 className="card-title mb-0">Deductions</h5>
//                                                             </Card.Header>
//                                                             <Card.Body>
//                                                                 <div className="mb-3">
//                                                                     <div className="d-flex justify-content-between align-items-center mb-2">
//                                                                         <h6 className="mb-0">Standard Deductions</h6>
//                                                                     </div>
//                                                                     {payrollData.deductions.map((deduction, index) => (
//                                                                         <div key={index} className="d-flex justify-content-between align-items-center ps-3 small">
//                                                                             <span>{deduction.name}</span>
//                                                                             <div>
//                                                                                 <span className="text-danger me-2">-{deduction.amount.toFixed(2)}</span>
//                                                                                 {currentCycle.status === 'draft' && (
//                                                                                     <Button
//                                                                                         variant="link"
//                                                                                         size="sm"
//                                                                                         className="text-danger p-0"
//                                                                                         onClick={() => removeItem(deduction.id, 'deductions')}
//                                                                                     >
//                                                                                         <FaTimes />
//                                                                                     </Button>
//                                                                                 )}
//                                                                             </div>
//                                                                         </div>
//                                                                     ))}
//                                                                     {payrollData.deductions.length === 0 && (
//                                                                         <div className="text-muted ps-3 small">No deductions added</div>
//                                                                     )}
//                                                                 </div>

//                                                                 <div className="mb-3">
//                                                                     <div className="d-flex justify-content-between align-items-center mb-2">
//                                                                         <h6 className="mb-0">Loan Deductions</h6>
//                                                                         {currentCycle.status === 'draft' && (
//                                                                             <Button
//                                                                                 variant="outline-primary"
//                                                                                 size="sm"
//                                                                                 onClick={() => setShowLoanModal(true)}
//                                                                             >
//                                                                                 <FaPlus className="me-1" /> Add
//                                                                             </Button>
//                                                                         )}
//                                                                     </div>
//                                                                     {payrollData.loans.map((loan, index) => (
//                                                                         <div key={index} className="d-flex justify-content-between align-items-center ps-3 small">
//                                                                             <span>{loan.title}</span>
//                                                                             <div>
//                                                                                 <span className="text-danger me-2">-{loan.amount.toFixed(2)}</span>
//                                                                                 {currentCycle.status === 'draft' && (
//                                                                                     <Button
//                                                                                         variant="link"
//                                                                                         size="sm"
//                                                                                         className="text-danger p-0"
//                                                                                         onClick={() => removeItem(loan.id, 'loans')}
//                                                                                     >
//                                                                                         <FaTimes />
//                                                                                     </Button>
//                                                                                 )}
//                                                                             </div>
//                                                                         </div>
//                                                                     ))}
//                                                                     {payrollData.loans.length === 0 && (
//                                                                         <div className="text-muted ps-3 small">No loan deductions added</div>
//                                                                     )}
//                                                                 </div>

//                                                                 <div className="d-flex justify-content-between mt-3 pt-2 border-top">
//                                                                     <strong>Total Deductions:</strong>
//                                                                     <strong className="text-danger">-{payrollData.totalDeductions.toFixed(2)}</strong>
//                                                                 </div>
//                                                             </Card.Body>
//                                                         </Card>
//                                                     </Col>
//                                                 </Row>
//                                             </>
//                                         )}
//                                     </Card.Body>
//                                 </Card>
//                             </Col>
//                         </Row>
//                     )}

//                     {/* Modals */}
//                     <CreateCycleModal />
//                     <DeductionModal />
//                     <BonusModal />
//                     <OvertimeModal />
//                     <LoanModal />
//                     {selectedEmployee && (
//                         <PayslipModal 
//                             employee={employees.find(e => e.id == selectedEmployee)} 
//                             data={payrollData} 
//                         />
//                     )}
//                 </div>
//             </div>
//         </div>
//     );
// };

// export default PayrollCycleList;





import React, { useState, useEffect, useMemo } from 'react';
import axios from 'axios';
import Swal from 'sweetalert2';
import {
    FaPlus, FaTimes, FaEdit, FaCheck, FaFileExport, FaEye,
    FaFilter, FaSearch, FaMoneyBillWave, FaCoins, FaPiggyBank,
    FaClock, FaFileInvoiceDollar, FaDownload
} from 'react-icons/fa';
import {
    Modal, Button, Form, Row, Col, Card, Badge, Table,
    Offcanvas, InputGroup, Dropdown
} from 'react-bootstrap';
import EmployeePayrollOffcanvas from "./EmployeePayrollOffcanvas";
import PayslipBatchPDF from "./PayslipBatchPDF";
import { PDFDownloadLink } from "@react-pdf/renderer";


const PayrollCycleList = () => {
    const [showEmployeeOffcanvas, setShowEmployeeOffcanvas] = useState(false);

    const [employees, setEmployees] = useState([]);
    const [payrollCycles, setPayrollCycles] = useState([]);
    const [currentCycle, setCurrentCycle] = useState(null);
    const [month, setMonth] = useState(new Date().getMonth() + 1);
    const [year, setYear] = useState(new Date().getFullYear());
    const [payslips, setPayslips] = useState([]);
    const [loading, setLoading] = useState(false);
    const [showFilters, setShowFilters] = useState(false);
    const [showEmployeeModal, setShowEmployeeModal] = useState(false);
    const [selectedEmployee, setSelectedEmployee] = useState(null);
    const [allowances, setAllowances] = useState([]);
    const [deductions, setDeductions] = useState([]);
    const [newBonus, setNewBonus] = useState({ amount: 0 });
    const [newOvertime, setNewOvertime] = useState({ hours: 0, rate: 0, amount: 0 });
    const [selectedDeduction, setSelectedDeduction] = useState('');
    const [deductionAmount, setDeductionAmount] = useState(0);
    const [processing, setProcessing] = useState(false);

    const token = JSON.parse(localStorage.getItem("user-info"))?.token;
    const origin = localStorage.getItem("user-origin");
    const [employeePayrollData, setEmployeePayrollData] = useState(null);
    const [employeeDetails, setEmployeeDetails] = useState(null);
    const [actionType, setActionType] = useState('edit');
    const [employeeFilter, setEmployeeFilter] = useState('');
    const [paymentMethodFilter, setPaymentMethodFilter] = useState(''); // '' = all, 'Bank', 'Exchange'

    const months = [
        { value: 1, label: "January" },
        { value: 2, label: "February" },
        { value: 3, label: "March" },
        { value: 4, label: "April" },
        { value: 5, label: "May" },
        { value: 6, label: "June" },
        { value: 7, label: "July" },
        { value: 8, label: "August" },
        { value: 9, label: "September" },
        { value: 10, label: "October" },
        { value: 11, label: "November" },
        { value: 12, label: "December" }
    ];

    const years = Array.from({ length: 10 }, (_, i) => new Date().getFullYear() - 5 + i);

    useEffect(() => {
        fetchEmployees();
        // fetchPayrollCycles();
        fetchDeductions();
    }, []);

    useEffect(() => {
        if (month && year) {
            fetchCycle();
        }
    }, [month, year]);

    const fetchEmployees = async () => {
        try {
            const res = await axios.get(
                `${process.env.REACT_APP_BACKEND_URL}/api/employee`,
                { headers: { Authorization: `Bearer ${token}`, "Tenant-Origin": origin } }
            );
            setEmployees(res.data.data || []);
        } catch (err) {
            console.error("Error fetching employees:", err);
        }
    };

    const fetchCycle = async () => {
        try {
            const res = await axios.get(
                `${process.env.REACT_APP_BACKEND_URL}/api/payroll-cycles`,
                {
                    headers: { Authorization: `Bearer ${token}`, "Tenant-Origin": origin },
                    params: { month, year },
                }
            );

            const currentCycle = res.data.find(
                (c) => parseInt(c.month) === parseInt(month) && parseInt(c.year) === parseInt(year)
            );

            if (currentCycle) {
                setCurrentCycle(currentCycle);
                fetchPayslips(currentCycle.id);
            } else {
                // Automatically create cycle if it doesn't exist
                await handleCreateCycle();
            }
        } catch (err) {
            console.error(err);
            setCurrentCycle(null);
            setPayslips([]);
        }
    };

    // Modify handleCreateCycle to not show success message for automatic creation
    const handleCreateCycle = async (showAlert = true) => {
        try {
            const res = await axios.post(
                `${process.env.REACT_APP_BACKEND_URL}/api/payroll-cycles`,
                { month, year },
                {
                    headers: { Authorization: `Bearer ${token}`, "Tenant-Origin": origin },
                    skipLoader: true,
                }
            );
            setCurrentCycle(res.data.cycle);
            setPayslips([]);
            fetchCycle();
            // if (showAlert) {
            //     Swal.fire("Success!", "Payroll cycle created successfully.", "success");
            // }
        } catch (err) {
            if (showAlert) {
                Swal.fire("Error!", err.response?.data?.message || "Error creating cycle", "error");
            }
        }
    };
    const handleProcessCycle = async () => {
        if (!currentCycle) return;
        setProcessing(true);
        try {
            await axios.post(
                `${process.env.REACT_APP_BACKEND_URL}/api/payroll/cycle/${currentCycle.id}/process`,
                {},
                { headers: { Authorization: `Bearer ${token}`, "Tenant-Origin": origin } }
            );
            // Swal.fire("Success!", "Payroll processed successfully.", "success");
            fetchCycle();
        } catch (err) {
            Swal.fire("Error!", err.response?.data?.message || "Error processing cycle", "error");
        } finally {
            setProcessing(false);
        }
    };
    // // Modify handleEmployeeClick to use offcanvas instead of modal
    // const handleEmployeeClick = async (employee) => {
    //     setSelectedEmployee(employee);
    //     await fetchEmployeeDetails(employee.id);
    //     setShowEmployeeOffcanvas(true);
    //     setEmployeePayrollData(employee); // Reset before fetching new data

    //     // if (currentCycle) {
    //     //     await fetchEmployeePayrollData(employee.id, currentCycle.id);
    //     // }
    // };

    const fetchEmployeeDetails = async (employeeId) => {
        try {
            const response = await axios.get(
                `${process.env.REACT_APP_BACKEND_URL}/api/employee/${employeeId}`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Tenant-Origin": origin
                    }
                }
            );
            const data = response.data?.data;
            setEmployeeDetails(data);
            setEmployeePayrollData(initializePayrollData(data)); // Initialize immediately
            setShowEmployeeOffcanvas(true); // Show after state is ready
            return data;
        } catch (error) {
            console.error("Error fetching employee details:", error);
            Swal.fire("Error!", "Failed to load employee details", "error");
        }
    };

    const initializePayrollData = (details = {}) => {
        const contract = details.contract || {};
        return {
            id: details.id,
            basicSalary: parseFloat(contract.salary || 0),
            bonus: details.bonus ?? 0,               // take API bonus
            deductions: details.deductions || [],    // take API deductions
            loans: (details.loans || [])
                .filter(l => l.status === 'approved')
                .map(l => ({
                    id: l.id,
                    title: l.title,
                    amount: parseFloat(l.installment_amount || 0),
                })),
            overtime: details.overtime || [],
        };
    };





    const updatePayrollData = (key, value) => {
        setEmployeePayrollData(prev => ({
            ...prev,
            [key]: value
        }));
    };



    const handleAddDeduction = () => {
        if (!selectedDeduction || deductionAmount <= 0) {
            Swal.fire("Error!", "Please select a deduction type and enter a valid amount", "error");
            return;
        }

        // Ensure ID type matches
        const deductionId = Number(selectedDeduction);
        const deduction = deductions.find(d => d.id === deductionId);
        if (!deduction) return;

        setEmployeePayrollData(prev => {
            const newDeductions = [
                ...(prev.deductions || []),
                { id: deduction.id, name: deduction.name, amount: parseFloat(deductionAmount) },
            ];
            console.log("Updated deductions state:", newDeductions); // ✅ debug
            return { ...prev, deductions: newDeductions };
        });

        setSelectedDeduction('');
        setDeductionAmount(0);
    };





    useEffect(() => {
        console.log("Payroll data updated:", employeePayrollData);
    }, [employeePayrollData]);

    useEffect(() => {
        if (!currentCycle) return;

        const filters = {};
        if (employeeFilter) filters.employee_id = employeeFilter;
        if (paymentMethodFilter) filters.payment_method = paymentMethodFilter;

        fetchPayslips(currentCycle.id, filters);
    }, [currentCycle?.id, employeeFilter, paymentMethodFilter]);

    // Remove deduction
    const removeDeduction = (id) => {
        const updatedDeductions = (employeePayrollData.deductions || []).filter(d => d.id !== id);
        updatePayrollData("deductions", updatedDeductions);
    };

    // Memoized totals to prevent re-renders flicker
const payrollTotals = useMemo(() => {
    if (!employeePayrollData || !employeeDetails) return {
        overtimeTotal: 0,
        allowancesTotal: 0,
        loansTotal: 0,
        deductionsTotal: 0,
        totalDeductions: 0,
        grossSalary: 0,
        netSalary: 0,
    };

    const overtimeTotal = (employeePayrollData.overtime || []).reduce(
        (sum, ot) => sum + (parseFloat(ot.hours || 0) * parseFloat(ot.rate || 0)),
        0
    );

    const allowancesTotal = (employeeDetails.contract?.allowances || []).reduce(
        (sum, a) => sum + (parseFloat(a.pivot?.amount) || 0),
        0
    );

    const loansTotal = (employeePayrollData.loans || []).reduce(
        (sum, l) => sum + (parseFloat(l.amount) || 0),
        0
    );

    const deductionsTotal = (employeePayrollData.deductions || []).reduce(
        (sum, d) => sum + (parseFloat(d.amount) || 0),
        0
    );

    const totalDeductions = loansTotal + deductionsTotal;

    const grossSalary =
        parseFloat(employeePayrollData.basicSalary || 0) +
        overtimeTotal +
        allowancesTotal +
        parseFloat(employeePayrollData.bonus || 0);

    const netSalary = grossSalary - totalDeductions;

    return {
        overtimeTotal,
        allowancesTotal,
        loansTotal,
        deductionsTotal,
        totalDeductions,
        grossSalary,
        netSalary,
    };
}, [employeePayrollData, employeeDetails]);



    const handleEmployeeClick = async (employee, action = 'edit') => {
        setActionType(action);
        try {
            setSelectedEmployee(employee);

            const res = await axios.get(
                `${process.env.REACT_APP_BACKEND_URL}/api/employee/${employee.id}`,
                { headers: { Authorization: `Bearer ${token}`, "Tenant-Origin": origin } ,
                    params: { cycle_id: currentCycle.id }
}
            );

            const details = res.data?.data;
            if (!details) {
                Swal.fire("Error", "Employee data not found", "error");
                return;
            }

            // ensure deductions array exists
            details.deductions = details.deductions || [];

            setEmployeeDetails(details);

            // Initialize payroll data fresh from API
         setEmployeePayrollData(initializePayrollData({
    ...details,
    bonus: details.payslip_for_cycle?.bonus || 0,
    deductions: details.payslip_for_cycle?.deductions || [],
}));

            setSelectedDeduction("");
            setDeductionAmount(0);
            setShowEmployeeOffcanvas(true);
        } catch (err) {
            console.error(err);
            Swal.fire("Error!", "Failed to load employee details", "error");
        }
    };


    const handleSaveEmployeePayroll = async () => {
        if (!employeePayrollData || !currentCycle) return;

        try {
            const payload = {
                employee_id: employeePayrollData.id,  // employee ID
                cycle_id: currentCycle.id,           // current payroll cycle
                bonus: employeePayrollData.bonus || 0,
                deductions: (employeePayrollData.deductions || []).map(d => ({ id: d.id, amount: d.amount })),
            };
            console.log("Saving payroll payload:", payload); // 👀 check here

            await axios.put(
                `${process.env.REACT_APP_BACKEND_URL}/api/payroll/cycle/payslip`,
                payload,
                { headers: { Authorization: `Bearer ${token}`, "Tenant-Origin": origin } }
            );

            Swal.fire("Success!", "Payroll updated successfully", "success");
            setShowEmployeeOffcanvas(false);
            fetchCycle(); // refresh cycle data
        } catch (error) {
            console.error(error);
            Swal.fire("Error!", "Failed to save payroll", "error");
        }
    };


    const removeItem = (id, field) => {
        const updatedItems = employeePayrollData[field].filter(item => item.id !== id);
        updatePayrollData(updatedItems, field);
    };
    const fetchDeductions = async () => {
        try {
            const res = await axios.get(
                `${process.env.REACT_APP_BACKEND_URL}/api/deductions`,
                { headers: { Authorization: `Bearer ${token}`, "Tenant-Origin": origin } }
            );
            setDeductions(res.data.data || []);
        } catch (err) {
            console.error("Error fetching deductions:", err);
        }
    };

    // const fetchPayslips = async (cycleId) => {
    //     try {
    //         const res = await axios.get(
    //             `${process.env.REACT_APP_BACKEND_URL}/api/payroll/cycle/${cycleId}/payslips`,
    //             { headers: { Authorization: `Bearer ${token}`, "Tenant-Origin": origin } }
    //         );
    //         setPayslips(res.data || []);
    //     } catch (err) {
    //         console.error("Error fetching payslips:", err);
    //         setPayslips([]);
    //     }
    // };

    const fetchPayslips = async (cycleId, filters = {}) => {
        try {
            const res = await axios.get(
                `${process.env.REACT_APP_BACKEND_URL}/api/payroll/cycle/${cycleId}/payslips`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Tenant-Origin": origin
                    },
                    params: filters, // 👈 extra query params
                }
            );
            setPayslips(res.data || []);
        } catch (err) {
            console.error("Error fetching payslips:", err);
            setPayslips([]);
        }
    };

    const getStatusBadge = (status) => {
        switch (status) {
            case 'open':
                return <Badge bg="warning">Open</Badge>;
            case 'processed':
                return <Badge bg="success">Processed</Badge>;
            case 'closed':
                return <Badge bg="secondary">Closed</Badge>;
            default:
                return <Badge bg="light" text="dark">{status}</Badge>;
        }
    };

    const filteredPayslips = payslips
        .filter(p => !employeeFilter || p.employee?.id == employeeFilter)
        .filter(p => !paymentMethodFilter || p.employee?.payment_method === paymentMethodFilter);

    const PayrollCycleCard = () => {
        const totalGross = filteredPayslips.reduce((sum, p) => sum + parseFloat(p.gross_salary || 0), 0);
        const totalNet = filteredPayslips.reduce((sum, p) => sum + parseFloat(p.net_salary || 0), 0);
        const totalDeductions = totalGross - totalNet;

        return (
            <Card className="mb-4">
                <Card.Header className="bg-light">
                    <div className="d-flex justify-content-between align-items-center">
                        <h5 className="card-title mb-0">
                            {months.find((m) => m.value === currentCycle.month)?.label} {currentCycle.year} Payroll
                        </h5>
                        {getStatusBadge(currentCycle.status)}
                    </div>
                </Card.Header>
                <Card.Body>
                    <Row>
                        <Col md={3} sm={6} className="mb-3">
                            <div className="text-center">
                                <div className="p-3 border rounded">
                                    <h4 className="text-primary mb-1">{payslips.length}</h4>
                                    <p className="text-muted mb-0">Employees</p>
                                </div>
                            </div>
                        </Col>
                        <Col md={3} sm={6} className="mb-3">
                            <div className="text-center">
                                <div className="p-3 border rounded">
                                    <h4 className="text-success mb-1">{totalGross.toFixed(2)}</h4>
                                    <p className="text-muted mb-0">Total Gross</p>
                                </div>
                            </div>
                        </Col>
                        <Col md={3} sm={6} className="mb-3">
                            <div className="text-center">
                                <div className="p-3 border rounded">
                                    <h4 className="text-danger mb-1">{totalDeductions.toFixed(2)}</h4>
                                    <p className="text-muted mb-0">Total Deductions</p>
                                </div>
                            </div>
                        </Col>
                        <Col md={3} sm={6} className="mb-3">
                            <div className="text-center">
                                <div className="p-3 border rounded bg-light">
                                    <h4 className="text-primary mb-1">{totalNet.toFixed(2)}</h4>
                                    <p className="text-muted mb-0">Net Payroll</p>
                                </div>
                            </div>
                        </Col>
                    </Row>


                </Card.Body>
            </Card>
        );
    };





    return (
        <div className="main-content">
            <div className="page-content">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-12">
                            <div className="page-title-box d-sm-flex align-items-center justify-content-between">
                                <h4 className="mb-sm-0 font-size-18">Payroll Batch Processing</h4>
                                <div className="page-title-right">
                                    <ol className="breadcrumb m-0">
                                        <li className="breadcrumb-item"><a href="#">Payroll</a></li>
                                        <li className="breadcrumb-item active">Batch Processing</li>
                                    </ol>
                                </div>
                            </div>
                        </div>
                    </div>

                    <Row>
                        <Col lg={12}>
                            <Card>
                                <Card.Body>
                                    <div className="d-flex justify-content-between align-items-center mb-3">
                                        <h4 className="card-title mb-0">Payroll Cycle Management</h4>
                                        <div className="d-flex gap-2">
                                            {/* Filters Button */}
                                            <Button
                                                variant="outline-secondary"
                                                onClick={() => setShowFilters(!showFilters)}
                                            >
                                                <FaFilter className="me-1" /> Filters
                                            </Button>

                                            {/* Download PDF Button */}
                                            {filteredPayslips.length > 0 && (
                                                <
                                                    PDFDownloadLink
                                                    document={
                                                        <PayslipBatchPDF
                                                            companyName="Systech Technology"
                                                            month={months.find((m) => m.value === month)?.label}
                                                            year={year}
                                                            payslips={filteredPayslips}
                                                        />
                                                    }
                                                    fileName={`Payroll_${month}_${year}.pdf`}
                                                >
                                                    {({ loading }) =>
                                                        loading ? (
                                                            <Button variant="secondary" disabled>
                                                                Generating PDF...
                                                            </Button>
                                                        ) : (
                                                            <Button variant="outline-primary">
                                                                <FaDownload className="me-1" /> Download
                                                            </Button>
                                                        )
                                                    }
                                                </PDFDownloadLink>
                                            )}
                                        </div>
                                    </div>



                                    {showFilters && (
                                        <Row className="mb-3 p-3 border rounded">
                                            <Col md={4}>
                                                <div className="mb-3">
                                                    <label className="form-label">Month</label>
                                                    <select
                                                        className="form-select"
                                                        value={month}
                                                        onChange={(e) => setMonth(parseInt(e.target.value))}
                                                    >
                                                        {months.map((m) => (
                                                            <option key={m.value} value={m.value}>
                                                                {m.label}
                                                            </option>
                                                        ))}
                                                    </select>
                                                </div>
                                            </Col>
                                            <Col md={4}>
                                                <div className="mb-3">
                                                    <label className="form-label">Year</label>
                                                    <select
                                                        className="form-select"
                                                        value={year}
                                                        onChange={(e) => setYear(parseInt(e.target.value))}
                                                    >
                                                        {years.map((y) => (
                                                            <option key={y} value={y}>
                                                                {y}
                                                            </option>
                                                        ))}
                                                    </select>
                                                </div>
                                            </Col>
                                            <Col md={4}>
                                                <div className="mb-3">
                                                    <label className="form-label">Employee</label>
                                                    <select
                                                        className="form-select"
                                                        value={employeeFilter}
                                                        onChange={(e) => setEmployeeFilter(e.target.value)}
                                                    >
                                                        <option value="">All Employees</option>
                                                        {employees.map(emp => (
                                                            <option key={emp.id} value={emp.id}>
                                                                {emp.first_name} {emp.last_name}
                                                            </option>
                                                        ))}
                                                    </select>
                                                </div>
                                            </Col>
                                            <Col md={4}>
                                                <div className="mb-3">
                                                    <label className="form-label">Payment Method</label>
                                                    <select
                                                        className="form-select"
                                                        value={paymentMethodFilter}
                                                        onChange={(e) => setPaymentMethodFilter(e.target.value)}
                                                    >
                                                        <option value="">All Methods</option>
                                                        <option value="Bank">Bank</option>
                                                        <option value="Exchange">Exchange</option>
                                                    </select>
                                                </div>
                                            </Col>
                                        </Row>
                                    )}


                                    <Row className="mb-4">
                                        <Col md={12}>
                                            <Card className="bg-light">
                                                <Card.Body className="py-2">
                                                    <div className="d-flex justify-content-between align-items-center">
                                                        <div>
                                                            <h6 className="mb-0">Current Selection: {months.find((m) => m.value === month)?.label} {year}</h6>
                                                        </div>
                                                        <div>
                                                            {!currentCycle ? (
                                                                <Button variant="success" onClick={handleCreateCycle}>
                                                                    Create Cycle
                                                                </Button>
                                                            ) : currentCycle.status === "open" ? (
                                                                <Button
                                                                    variant="primary"
                                                                    onClick={handleProcessCycle}
                                                                    disabled={processing}
                                                                >
                                                                    {processing ? 'Processing...' : 'Process Payroll'}
                                                                </Button>
                                                            ) : (
                                                                <span className="text-success fw-bold">Payslips generated ✅</span>
                                                            )}
                                                        </div>
                                                    </div>
                                                </Card.Body>
                                            </Card>
                                        </Col>
                                    </Row>

                                    {currentCycle ? (
                                        <>
                                            <PayrollCycleCard />
                                            {filteredPayslips.length > 0 && (
                                                <Card>
                                                    <Card.Header className="bg-light">
                                                        <h5 className="card-title mb-0">Employee Payslips</h5>
                                                    </Card.Header>
                                                    <Card.Body>
                                                        <div className="table-responsive">
                                                            <Table hover>
                                                                <thead className="table-light">
                                                                    <tr>
                                                                        <th>Employee</th>
                                                                        <th className="text-end">Basic</th>
                                                                        <th className="text-end">Allowances</th>
                                                                        <th className="text-end">Deductions</th>
                                                                        <th className="text-end">Loans</th>
                                                                        <th className="text-end">Overtime</th>
                                                                        <th className="text-end">Bonus</th>

                                                                        <th className="text-end">Gross</th>
                                                                        <th className="text-end">Net</th>
                                                                        <th className="text-center">Actions</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    {filteredPayslips.map((p) => (
                                                                        <tr key={p.id}>
                                                                            <td>
                                                                                <div>
                                                                                    {/* <div className="avatar-xs bg-primary text-white rounded-circle d-flex align-items-center justify-content-center me-2">
                                                                                        {p.employee?.first_name?.charAt(0)}{p.employee?.last_name?.charAt(0)}
                                                                                    </div> */}
                                                                                    <div>
                                                                                        {p.employee.first_name} {p.employee.last_name}
                                                                                        {/* <div className="small text-muted">{p.employee.employee_code}</div> */}
                                                                                    </div>
                                                                                </div>
                                                                            </td>
                                                                            <td className="text-end">{parseFloat(p.basic || 0).toFixed(2)}</td>
                                                                            <td className="text-end text-success">{parseFloat(p.total_allowances || 0).toFixed(2)}</td>
                                                                            <td className="text-end text-danger">{parseFloat(p.total_deductions || 0).toFixed(2)}</td>
                                                                            <td className="text-end text-danger">{parseFloat(p.loan_deduction || 0).toFixed(2)}</td>
                                                                            <td className="text-end text-success">{parseFloat(p.overtime_pay || 0).toFixed(2)}</td>
                                                                            <td className="text-end text-success">{parseFloat(p.bonus || 0).toFixed(2)}</td>
                                                                            <td className="text-end fw-semibold">{parseFloat(p.gross_salary || 0).toFixed(2)}</td>
                                                                            <td className="text-end fw-bold text-primary">{parseFloat(p.net_salary || 0).toFixed(2)}</td>
                                                                            {/* <td className="text-center">
                                                                                <Button
                                                                                    variant="outline-primary"
                                                                                    size="sm"
                                                                                    onClick={() => handleEmployeeClick(p.employee)}
                                                                                >
                                                                                    <FaEdit /> Edit
                                                                                </Button>
                                                                            </td> */}
                                                                            <td className="text-center">
                                                                                <Dropdown>
                                                                                    <Dropdown.Toggle variant="outline-primary" size="sm" id="dropdown-basic">
                                                                                        Actions
                                                                                    </Dropdown.Toggle>
                                                                                    <Dropdown.Menu>
                                                                                        <Dropdown.Item
                                                                                            onClick={() => handleEmployeeClick(p.employee, 'edit')}
                                                                                        >
                                                                                            <FaEdit className="me-2" /> Edit Payroll
                                                                                        </Dropdown.Item>
                                                                                        <Dropdown.Item
                                                                                            onClick={() => handleEmployeeClick(p.employee, 'view')}
                                                                                        >
                                                                                            <FaEye className="me-2" /> View Details
                                                                                        </Dropdown.Item>
                                                                                    </Dropdown.Menu>
                                                                                </Dropdown>
                                                                            </td>
                                                                        </tr>
                                                                    ))}
                                                                </tbody>
                                                            </Table>
                                                        </div>
                                                    </Card.Body>
                                                </Card>
                                            )}
                                        </>
                                    ) : (
                                        <div className="text-center py-5">
                                            <div className="avatar-md mx-auto mb-4">
                                                <div className="avatar-title bg-primary-subtle text-primary rounded-circle display-5">
                                                    <FaMoneyBillWave />
                                                </div>
                                            </div>
                                            <h5>No Payroll Cycle Found</h5>
                                            <p className="text-muted">Create a new payroll cycle for {months.find((m) => m.value === month)?.label} {year}</p>
                                            <Button variant="primary" onClick={handleCreateCycle}>
                                                Create New Cycle
                                            </Button>
                                        </div>
                                    )}
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>

                    {/* Modals */}
                    {/* <EmployeePayrollOffcanvas /> */}
                    <EmployeePayrollOffcanvas
                        show={showEmployeeOffcanvas}
                        onHide={() => setShowEmployeeOffcanvas(false)}
                        employeePayrollData={employeePayrollData}
                        employeeDetails={employeeDetails}
                        payrollTotals={payrollTotals}
                        updatePayrollData={updatePayrollData}
                        selectedDeduction={selectedDeduction}
                        setSelectedDeduction={setSelectedDeduction}
                        deductionAmount={deductionAmount}
                        setDeductionAmount={setDeductionAmount}
                        deductions={deductions}
                        handleAddDeduction={handleAddDeduction}
                        removeDeduction={removeDeduction}
                        handleSave={handleSaveEmployeePayroll}
                        actionType={actionType}
                    />
                </div>
            </div>
        </div>
    );
};

export default PayrollCycleList;


